const ar = {
  // Navigation
  nav: {
    products: 'منتجات SaaS',
    software: 'البرمجيات',
    services: 'الخدمات',
    pricing: 'الأسعار',
    resources: 'الموارد',
    about: 'من نحن',
    contact: 'اتصل بنا',
    login: 'تسجيل الدخول',
    getStarted: 'ابدأ الآن',
    cmms: 'نظام إدارة الصيانة',
    cmmsDesc: 'نظام إدارة الصيانة الشامل',
    chatbot: 'المحادثة الآلية بالذكاء الاصطناعي',
    chatbotDesc: 'أتمتة دعم العملاء',
    sfms: 'SFMS',
    sfmsDesc: 'نظام إدارة المرافق الرياضية',
    gms: 'GMS',
    gmsDesc: 'نظام إدارة الصالات الرياضية',
    digitalTransformation: 'التحول الرقمي',
    digitalTransformationDesc: 'الاستشارات والاستراتيجية',
    customDevelopment: 'التطوير المخصص',
    customDevelopmentDesc: 'حلول برمجية مخصصة',
    blog: 'المدونة',
    blogDesc: 'مقالات ورؤى',
    docs: 'التوثيق',
    docsDesc: 'أدلة المنتجات',
    help: 'مركز المساعدة',
    helpDesc: 'الأسئلة الشائعة والدعم',
    caseStudies: 'دراسات الحالة',
    caseStudiesDesc: 'قصص النجاح',
  },

  // Hero Section
  hero: {
    badge: 'موثوق به من قِبَل شركات حول العالم',
    headline1: 'حوّل أعمالك مع',
    headline2: 'حلول ذكية',
    subheadline: 'منصة SaaS على مستوى المؤسسات تقدم نظام إدارة الصيانة، والمحادثة الآلية بالذكاء الاصطناعي، واستشارات التحول الرقمي، وتطوير البرمجيات المخصصة.',
    feature1: 'مساعدة الإعداد متضمنة',
    feature2: 'خطط شهرية أو سنوية',
    feature3: 'إلغاء في أي وقت',
    ctaPrimary: 'ابدأ الآن',
    ctaSecondary: 'شاهد العرض التوضيحي',
    trustedBy: 'موثوق به من قبل الشركات الرائدة',
  
},

  // Products
  products: {
    title1: 'منتجاتنا',
    title2: 'SaaS',
    subtitle: 'اختر من بين حلول SaaS القوية المصممة لحل تحديات الأعمال الحقيقية',
    cmmsTitle: 'نظام إدارة الصيانة',
    cmmsSubtitle: 'نظام إدارة الصيانة الشامل',
    cmmsDesc: 'قم بتبسيط عمليات الصيانة الخاصة بك من خلال حل CMMS الشامل لدينا. تتبع الأصول وإدارة أوامر العمل وتحسين جداول الصيانة الوقائية.',
    cmmsFeature1: 'تتبع وإدارة الأصول',
    cmmsFeature2: 'أتمتة أوامر العمل',
    cmmsFeature3: 'جدولة الصيانة الوقائية',
    cmmsFeature4: 'إدارة المخزون',
    cmmsFeature5: 'لوحات معلومات وتحليلات فورية',
    cmmsFeature6: 'تطبيق الجوال للفنيين',
    cmmsPrice: 'يبدأ من 99 دولار شهريًا',
    chatbotTitle: 'المحادثة الآلية بالذكاء الاصطناعي',
    chatbotSubtitle: 'أتمتة دعم العملاء',
    chatbotDesc: 'انشر محادثات آلية ذكية تعمل بالذكاء الاصطناعي توفر دعمًا للعملاء على مدار الساعة. قم بالتدريب على مستنداتك ومحتوى موقعك للحصول على استجابات دقيقة وسياقية.',
    chatbotFeature1: 'معالجة اللغة الطبيعية',
    chatbotFeature2: 'التدريب على المستندات والمواقع',
    chatbotFeature3: 'دعم متعدد اللغات',
    chatbotFeature4: 'تحليلات المحادثة',
    chatbotFeature5: 'تكامل سهل مع الموقع',
    chatbotFeature6: 'مظهر قابل للتخصيص',
    chatbotFeature7: 'تحويل فوري إلى وكيل بشري',
    chatbotPrice: 'يبدأ من 49 دولار شهريًا',
    startingAt: 'يبدأ من',
    learnMore: 'اعرف المزيد',
    viewPricing: 'عرض جميع الخطط والأسعار',
  },

  // Services
  services: {
    title1: 'خدمات',
    title2: 'احترافية',
    subtitle: 'استشارات خبراء وتطوير مخصص لتسريع رحلتك الرقمية',
    dtTitle: 'استشارات التحول الرقمي',
    dtDesc: 'حوّل أعمالك مع خدماتنا الاستشارية المتخصصة. نساعدك على الاستفادة من التكنولوجيا لتحسين العمليات وتعزيز تجربة العملاء ودفع النمو.',
    dtCap1: 'الاستراتيجية وخارطة الطريق',
    dtCap2: 'أتمتة العمليات',
    dtCap3: 'إدارة التغيير',
    dtDeliverTitle: 'ما نقدمه:',
    dtDeliver1: 'تقييم شامل للتكنولوجيا',
    dtDeliver2: 'تطوير الاستراتيجية الرقمية وخارطة الطريق',
    dtDeliver3: 'تحسين العمليات والأتمتة',
    dtDeliver4: 'دعم إدارة التغيير',
    dtDeliver5: 'تحليل العائد على الاستثمار وتتبع مؤشرات الأداء',
    dtCta: 'جدولة استشارة مجانية',
    dtPrice: 'تسعير مخصص بناءً على النطاق',
    cdTitle: 'تطوير التطبيقات المخصصة',
    cdDesc: 'احصل على حلول برمجية مخصصة مصممة خصيصًا لاحتياجات عملك. يقدم فريقنا الخبير تطبيقات ويب وجوال عالية الجودة باستخدام التقنيات الحديثة.',
    cdCap1: 'التطوير الكامل',
    cdCap2: 'منهجية أجايل',
    cdCap3: 'ضمان الجودة',
    cdDeliver1: 'تطوير تطبيقات الويب والجوال',
    cdDeliver2: 'تطوير وتكامل واجهات برمجة التطبيقات',
    cdDeliver3: 'تحديث الأنظمة القديمة',
    cdDeliver4: 'إعداد البنية التحتية السحابية',
    cdDeliver5: 'الدعم والصيانة المستمرة',
    cdCta: 'طلب عرض سعر للمشروع',
    cdPrice: '',
    projects: 'المشاريع',
    satisfaction: 'الرضا',
    support: 'الدعم',
    notSure: 'غير متأكد من الخدمة التي تناسب احتياجاتك؟',
    notSureDesc: 'حدد موعدًا لاستشارة مجانية ودع خبراءنا يرشدونك',
    contactUs: 'اتصل بنا اليوم',
  },

  // Features
  features: {
    title1: 'لماذا تختار',
    title2: 'mwbTechs',
    subtitle: 'ميزات على مستوى المؤسسات مصممة للأعمال الحديثة',
    security: 'أمان المؤسسة',
    securityDesc: 'تشفير على مستوى البنوك، امتثال SOC 2، وعمليات تدقيق أمنية منتظمة للحفاظ على أمان بياناتك.',
    fast: 'سريع جدًا',
    fastDesc: 'أداء محسّن مع ضمان وقت تشغيل 99.9٪ وأوقات استجابة أقل من ثانية.',
    collaboration: 'تعاون الفريق',
    collaborationDesc: 'التحكم في الوصول على أساس الدور، والتحديثات الفورية، والتواصل السلس للفريق.',
    analytics: 'تحليلات متقدمة',
    analyticsDesc: 'لوحات معلومات شاملة، وتقارير مخصصة، ورؤى قائمة على البيانات لاتخاذ قرارات أفضل.',
    multiLanguage: 'متعدد اللغات',
    multiLanguageDesc: 'دعم لغات متعددة مع ترجمة وتوطين تلقائيين.',
    privacy: 'خصوصية البيانات',
    privacyDesc: 'متوافق مع اللائحة العامة لحماية البيانات، وخيارات إقامة البيانات، والتحكم الكامل في معلوماتك.',
    support247: 'دعم على مدار الساعة',
    support247Desc: 'دعم العملاء على مدار الساعة عبر الدردشة والبريد الإلكتروني والهاتف مع وقت استجابة أقل من ساعتين.',
    mobile: 'تطبيقات الجوال',
    mobileDesc: 'تطبيقات iOS و Android للوصول أثناء التنقل من أي جهاز.',
    customers: 'العملاء النشطون',
    uptime: 'اتفاقية مستوى الخدمة',
    users: 'المستخدمون اليوميون',
    supportAvailable: 'الدعم المتاح',
  },

  // Pricing
  pricing: {
    title1: 'بسيطة،',
    title2: 'تسعير شفاف',
    subtitle: 'اختر الخطة المثالية لأعمالك.',
    monthly: 'شهري',
    annual: 'سنوي',
    save: 'وفر 20٪',
    cmmsPlans: 'خطط CMMS',
    chatbotPlans: 'خطط المحادثة الآلية',
    basic: 'أساسي',
    pro: 'احترافي',
    enterprise: 'مؤسسة',
    popular: 'الأكثر شعبية',
    perMonth: '/شهر',
    billedAnnually: 'يُفوتر سنويًا',
    startTrial: 'ابدأ الآن',
    contactSales: 'اتصل بالمبيعات',
    viewDetailed: 'عرض الأسعار والميزات التفصيلية',
    extraSlots: 'يمكن شراء تراخيص إضافية بشكل منفصل',
    extraMessages: 'يمكن شراء رسائل إضافية بشكل منفصل',
    extraMessagesRate: 'رسائل إضافية: {{price}}$ لكل 1,000',
  
    feat_unlimitedAssets: 'أصول غير محدودة',
    feat_assets: '{{n}} أصل',
    feat_unlimitedUsers: 'مستخدمون غير محدودون',
    feat_users: '{{n}} مستخدم',
    feat_unlimitedLocations: 'مواقع غير محدودة',
    feat_locations: '{{n}} موقع',
    feat_unlimitedBranches: 'فروع غير محدودة',
    feat_branches: '{{n}} فرع',
    feat_unlimitedMsgs: 'رسائل غير محدودة/شهر',
    feat_msgs: '{{n}} رسالة/شهر',
    feat_unlimitedChatbots: 'شات بوت غير محدود',
    feat_chatbots: '{{n}} شات بوت',
    feat_chatbot: '{{n}} شات بوت',
    feat_unlimitedDocs: 'مستندات غير محدودة لكل شات بوت',
    feat_docs: '{{n}} مستندات لكل شات بوت',
    feat_doc: '{{n}} مستند لكل شات بوت',
    feat_agents: '{{n}} وكلاء مباشرون مشمولون',
    feat_agent: '{{n}} وكيل مباشر مشمول',
    feat_channels: 'واتساب وإنستغرام وفيسبوك',
    descBasicCmms: 'مثالي للفرق الصغيرة',
    descProCmms: 'الأكثر شعبية للأعمال المتنامية',
    descEnterpriseCmms: 'للمؤسسات الكبيرة',
    descBasicChatbot: 'مناسب للمواقع الصغيرة',
    descProChatbot: 'الأفضل للأعمال المتنامية',
    descEnterpriseChatbot: 'للاستخدام عالي الحجم',
    feat_workOrders: 'إدارة أوامر العمل',
    feat_basicReports: 'تقارير أساسية',
    feat_emailSupport: 'دعم عبر البريد الإلكتروني',
    feat_mobileApp: 'الوصول عبر التطبيق المحمول',
    feat_advWorkOrders: 'أوامر عمل متقدمة',
    feat_preventive: 'الصيانة الوقائية',
    feat_inventory: 'إدارة المخزون',
    feat_prioritySupport: 'دعم ذو أولوية',
    feat_customReports: 'تقارير مخصصة',
    feat_apiAccess: 'الوصول إلى API',
    feat_allPro: 'جميع ميزات Pro',
    feat_customInteg: 'تكاملات مخصصة',
    feat_dedicatedMgr: 'مدير حساب مخصص',
    feat_phone247: 'دعم هاتفي 24/7',
    feat_advSecurity: 'أمان متقدم',
    feat_sla: 'ضمان SLA',
    feat_1website: 'زحف موقع واحد',
    feat_websites: 'زحف {{n}} مواقع',
    feat_basicAnalytics: 'تحليلات أساسية',
    feat_advAnalytics: 'تحليلات متقدمة',
    feat_customBranding: 'علامة تجارية مخصصة',
    feat_unlimMsgs: 'رسائل غير محدودة',
    feat_unlimDocs: 'مستندات غير محدودة',
    feat_unlimCrawls: 'زحف غير محدود',
    feat_support247: 'دعم 24/7',
    feat_whiteLabel: 'حل white-label',
},

  // Testimonials
  testimonials: {
    title1: 'محبوب من قبل',
    title2: 'العملاء في جميع أنحاء العالم',
    subtitle: 'شاهد ما يقوله عملاؤنا عن تجربتهم',
    trustedBy: 'موثوق به من قبل العلامات التجارية الرائدة في جميع أنحاء العالم',
  },

  // CTA
  cta: {
    title: 'هل أنت مستعد لتحويل عملك؟',
    subtitle: 'انضم إلى الشركات التي تثق في mwbTechs للتحول الرقمي',
    feature1: 'فاتورة شهرية أو سنوية',
    feature2: 'دعم ذو أولوية',
    feature3: 'إلغاء في أي وقت',
    feature4: 'مساعدة الإعداد متضمنة',
    startTrial: 'ابدأ الآن',
    talkToSales: 'تحدث إلى المبيعات',
    companies: 'الشركات',
    activeUsers: 'المستخدمون النشطون',
    uptime: 'وقت التشغيل',
    support: 'الدعم',
  },

  // Footer
  footer: {
    description: 'منصة SaaS على مستوى المؤسسات تقدم حلولًا مبتكرة للأعمال الحديثة. حوّل عملياتك بتقنيتنا المتطورة.',
    products: 'المنتجات',
    software: 'البرمجيات',
    services: 'الخدمات',
    resources: 'الموارد',
    company: 'الشركة',
    newsletter: 'اشترك في نشرتنا الإخبارية',
    newsletterDesc: 'احصل على آخر التحديثات والأخبار والعروض الحصرية المرسلة إلى بريدك الوارد.',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    subscribe: 'اشترك',
    subscribeSuccess: 'شكراً للاشتراك! تحقق من بريدك الوارد لرسالة التأكيد.',
    subscribeError: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    copyright: 'mwbTechs. جميع الحقوق محفوظة.',
    linkCmms: 'نظام CMMS',
    linkChatbot: 'روبوت الدردشة الذكي',
    linkSfms: 'SFMS',
    linkGms: 'GMS',
    linkPricing: 'الأسعار',
    linkDigitalTransformation: 'التحول الرقمي',
    linkCustomDevelopment: 'التطوير المخصص',
    linkDocumentation: 'التوثيق',
    linkHelpCenter: 'مركز المساعدة',
    linkCaseStudies: 'دراسات الحالة',
    linkAboutUs: 'من نحن',
    linkContact: 'اتصل بنا',
    linkPrivacy: 'سياسة الخصوصية',
    linkTerms: 'شروط الاستخدام',
    linkSecurity: 'الأمان',
  },

  // Contact
  contact: {
    title1: 'ابقَ على',
    title2: 'تواصل',
    subtitle: 'هل لديك سؤال أو مستعد لبدء مشروعك؟ نحن هنا للمساعدة!',
    info: 'معلومات الاتصال',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    hours: 'ساعات العمل',
    monday: 'الإثنين - الجمعة',
    saturday: 'السبت',
    sunday: 'الأحد',
    closed: 'مغلق',
    general: 'استفسار عام',
    consultation: 'طلب استشارة',
    quote: 'الحصول على عرض سعر للمشروع',
    success: 'تم إرسال الرسالة بنجاح!',
    successDesc: 'سنرد عليك في غضون 24 ساعة.',
    name: 'الاسم الكامل',
    company: 'الشركة',
    message: 'الرسالة',
    required: 'مطلوب',
    service: 'الخدمة المهتم بها',
    projectType: 'نوع المشروع',
    budget: 'نطاق الميزانية',
    timeline: 'الجدول الزمني',
    send: 'إرسال الرسالة',
    phoneHours: 'الإثنين-الجمعة 9ص-6م بتوقيت بيروت (EET)',
    companyPlaceholder: 'اسم الشركة',
    messagePlaceholderGeneral: 'كيف يمكننا مساعدتك؟',
    messagePlaceholderConsultation: 'أخبرنا عن تحديات أعمالك...',
    messagePlaceholderQuote: 'يرجى وصف متطلبات مشروعك...',
    selectService: 'اختر خدمة...',
    serviceDigitalTransformation: 'التحول الرقمي',
    serviceProcessAutomation: 'أتمتة العمليات',
    serviceStrategy: 'الاستراتيجية الرقمية',
    serviceChangeManagement: 'إدارة التغيير',
    selectProjectType: 'اختر نوع المشروع...',
    projectWebApp: 'تطبيق ويب',
    projectMobileApp: 'تطبيق جوال',
    projectApi: 'تطوير API',
    projectModernization: 'تحديث الأنظمة القديمة',
    projectCloud: 'حلول سحابية',
    selectBudget: 'اختر الميزانية...',
    selectTimeline: 'اختر الجدول الزمني...',
    timelineAsap: 'في أقرب وقت ممكن',
    timeline1to3: '1-3 أشهر',
    timeline3to6: '3-6 أشهر',
    timeline6plus: '6+ أشهر',
  },

  // Common
  common: {
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    comingSoon: 'قريبًا...',
  },

  login: {
    welcomeBack: 'مرحبًا بعودتك!',
    signInDesc: 'سجّل الدخول للوصول إلى حسابك ومواصلة إدارة عمليّاتك بكفاءة.',
    quickAccessTitle: 'وصول سريع إلى:',
    quickAccess1: 'لوحة المعلومات والتحليلات',
    quickAccess2: 'أوامر العمل والأصول',
    quickAccess3: 'إدارة المحادثة الآلية',
    quickAccess4: 'تعاون الفريق',
    quickAccess5: 'التقارير والرؤى',
    newUser: 'جديد في mwbTechs؟',
    startTrialPromo: 'أنشئ حسابك لتبدأ مع mwbTechs.',
    createAccount: 'إنشاء حساب',
    signIn: 'تسجيل الدخول',
    signInSubtitle: 'أدخل بيانات اعتمادك للوصول إلى حسابك',
    emailAddress: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    rememberMe: 'تذكّرني لمدة 30 يومًا',
    signingIn: 'جارٍ تسجيل الدخول...',
    noAccount: 'ليس لديك حساب؟',
    startFreeTrial: 'إنشاء حساب',
    loginFailed: 'فشل تسجيل الدخول',
    verificationEmailSent: 'تم إرسال بريد التحقق! يرجى التحقق من صندوق الوارد.',
    resendVerification: 'إعادة إرسال بريد التحقق',
    sending: 'جارٍ الإرسال...',
    twoFactor: 'المصادقة الثنائية',
    twoFactorDesc: 'أدخل الرمز من تطبيق المصادقة الخاص بك',
    twoFactorHint: 'تم طلب رمز التحقق لـ',
    verificationFailed: 'فشل التحقق',
    verificationCode: 'رمز التحقق',
    authenticatorHint: 'افتح تطبيق المصادقة (Google Authenticator أو Authy) وأدخل الرمز المكون من 6 أرقام.',
    verifying: 'جارٍ التحقق...',
    verifySignIn: 'تحقق وسجّل الدخول',
    troubleAuth: 'هل تواجه مشكلة مع تطبيق المصادقة؟',
    contactSupport: 'اتصل بالدعم',
    backToLogin: 'العودة إلى تسجيل الدخول',
    enterSixDigit: 'يرجى إدخال رمز مكون من 6 أرقام',
    invalidCode: 'رمز التحقق غير صالح. يرجى المحاولة مرة أخرى.',
    emailRequired: 'البريد الإلكتروني مطلوب',
    invalidEmail: 'عنوان البريد الإلكتروني غير صالح',
    passwordRequired: 'كلمة المرور مطلوبة',
  },

  signup: {
    title: 'ابدأ تجربتك المجانية اليوم',
    subtitle: 'انضم إلى أكثر من 2000 شركة تحوّل عملياتها مع mwbTechs',
    benefit1: 'تجربة مجانية 14 يومًا، لا حاجة لبطاقة ائتمان',
    benefit2: 'الوصول إلى جميع الميزات',
    benefit3: 'دعم ذو أولوية',
    benefit4: 'إلغاء في أي وقت',
    includedTitle: 'ما هو متضمَّن:',
    included1: 'وصول كامل إلى CMMS أو المحادثة الآلية',
    included2: 'مستخدمون غير محدودون خلال التجربة',
    included3: 'الوصول عبر تطبيق الجوال',
    included4: 'دعم عبر البريد الإلكتروني',
    included5: 'لا حاجة لبطاقة ائتمان',
    included6: 'مساعدة في الإعداد متضمنة',
    stepAccount: 'إنشاء حسابك',
    stepAccountDesc: 'أدخل تفاصيلك للبدء',
    stepCompany: 'معلومات الشركة',
    stepCompanyDesc: 'أخبرنا عن مؤسستك',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    emailAddress: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    trialLabel: 'ابدأ بتجربة مجانية لمدة 14 يومًا',
    trialDesc: 'لا حاجة لبطاقة ائتمان. وصول كامل لجميع الميزات.',
    continue: 'متابعة',
    companyName: 'اسم الشركة',
    industry: 'القطاع',
    companySize: 'حجم الشركة',
    selectSize: 'اختر الحجم',
    small: '1-50 موظفًا',
    medium: '51-250 موظفًا',
    large: '251-1000 موظف',
    enterprise: 'أكثر من 1000 موظف',
    phone: 'الهاتف',
    country: 'الدولة',
    timezone: 'المنطقة الزمنية',
    selectCountryFirst: 'اختر دولة أولاً',
    servicesInterested: 'ما الخدمات التي تهتم بها؟',
    cmmsName: 'CMMS',
    cmmsDesc: 'نظام إدارة الصيانة',
    chatbotName: 'المحادثة الآلية',
    chatbotDesc: 'روبوت دعم عملاء ذكي',
    agreeTerms: 'أوافق على',
    termsOfService: 'شروط الخدمة',
    and: 'و',
    privacyPolicy: 'سياسة الخصوصية',
    back: 'رجوع',
    startFreeTrial: 'ابدأ التجربة المجانية',
    creatingAccount: 'جارٍ إنشاء الحساب...',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟',
    signIn: 'تسجيل الدخول',
    welcomeTitle: 'مرحبًا بك في mwbTechs!',
    welcomeDesc: 'تم إنشاء حسابك بنجاح. تحقق من بريدك الإلكتروني لرابط التحقق.',
    goToLogin: 'الذهاب إلى تسجيل الدخول',
    selectService: 'يرجى اختيار خدمة واحدة على الأقل للمتابعة.',
    firstNameRequired: 'الاسم الأول مطلوب',
    lastNameRequired: 'اسم العائلة مطلوب',
    emailRequired: 'البريد الإلكتروني مطلوب',
    invalidEmail: 'عنوان البريد الإلكتروني غير صالح',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordMinLength: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
    passwordsMustMatch: 'كلمتا المرور غير متطابقتين',
    companySizeRequired: 'حجم الشركة مطلوب',
    companyNameRequired: 'اسم الشركة مطلوب',
    acceptTerms: 'يجب عليك قبول الشروط',
  },

  auth: {
    verifyEmail: 'تحقق من بريدك الإلكتروني',
    verifyDesc: 'أرسلنا رابط التحقق إلى عنوان بريدك الإلكتروني. يرجى التحقق من صندوق الوارد والنقر على الرابط لتفعيل حسابك.',
    verifyNote: 'لم تستلم البريد الإلكتروني؟ تحقق من مجلد الرسائل غير المرغوب فيها.',
    backToLogin: 'العودة إلى تسجيل الدخول',
    verifying: 'جارٍ التحقق من بريدك الإلكتروني...',
    verifiedTitle: 'تم التحقق من البريد الإلكتروني!',
    verifiedDesc: 'تم التحقق من بريدك الإلكتروني بنجاح. يمكنك الآن تسجيل الدخول إلى حسابك.',
    goToLogin: 'الذهاب إلى تسجيل الدخول',
    failedTitle: 'فشل التحقق',
    failedDesc: 'رابط التحقق غير صالح أو منتهي الصلاحية.',
    requestNew: 'طلب رابط جديد',
    forgotTitle: 'نسيت كلمة المرور؟',
    forgotDesc: 'أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة مرورك.',
    emailAddress: 'عنوان البريد الإلكتروني',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    sending: 'جارٍ الإرسال…',
    checkEmail: 'تحقق من بريدك الإلكتروني',
    checkEmailDesc: 'إذا كان هناك حساب مرتبط بهذا العنوان، فقد أرسلنا رابط إعادة تعيين كلمة المرور. يرجى التحقق من صندوق الوارد ومجلد الرسائل غير المرغوب فيها.',
    backToLoginLink: 'العودة إلى تسجيل الدخول',
    resetTitle: 'تعيين كلمة مرور جديدة',
    resetDesc: 'اختر كلمة مرور قوية لحسابك.',
    newPassword: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    resetButton: 'إعادة تعيين كلمة المرور',
    resetting: 'جارٍ إعادة التعيين…',
    resetSuccess: 'تمت إعادة تعيين كلمة المرور!',
    resetSuccessDesc: 'تم تحديث كلمة مرورك بنجاح. يمكنك الآن تسجيل الدخول بكلمة مرورك الجديدة.',
    invalidResetLink: 'رابط إعادة التعيين غير صالح',
    invalidResetDesc: 'رابط إعادة تعيين كلمة المرور مفقود أو غير صالح. يرجى طلب رابط جديد.',
    requestNewLink: 'طلب رابط جديد',
    passwordMin: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    passwordsNoMatch: 'كلمتا المرور غير متطابقتين',
  },

  cmmsPage: {
    badge: 'إدارة الصيانة',
    heroTitle: 'حل نظام إدارة الصيانة المتكامل للصيانة الحديثة',
    heroSubtitle: 'قم بتبسيط عمليات الصيانة وتقليل وقت التوقف وإطالة عمر الأصول مع نظام إدارة الصيانة الشامل الخاص بنا.',
    startFreeTrial: 'ابدأ الآن',
    scheduleDemo: 'جدولة عرض توضيحي',
    watchWalkthrough: 'مشاهدة العرض التوضيحي',
    videoSectionBadge: 'جولة تفصيلية بالمنتج',
    videoSectionTitle: 'شاهد mwbTechs CMMS في العمل',
    videoSectionSubtitle: 'شاهد العرض التوضيحي الكامل وتعرّف على كيفية إدارة الفرق للصيانة من اليوم الأول.',
    lessDowntime: 'أقل وقت توقف',
    fasterResponse: 'استجابة أسرع',
    avgSavings: 'متوسط التوفير',
    featuresTitle: 'ميزات قوية للتحكم الكامل في الصيانة',
    featuresSubtitle: 'كل ما تحتاجه لإدارة عمليات الصيانة بكفاءة',
    f1Title: 'إدارة الأصول',
    f1Desc: 'تتبع وإدارة جميع أصولك بسجلات تفصيلية وتاريخ الصيانة وتتبع دورة الحياة.',
    f2Title: 'الصيانة الوقائية',
    f2Desc: 'جدولة وأتمتة الصيانة الوقائية لتقليل وقت التوقف وإطالة عمر الأصول.',
    f3Title: 'مراقبة المخزون',
    f3Desc: 'إدارة مخزون قطع الغيار مع نقاط إعادة الطلب التلقائية وتكامل الموردين.',
    f4Title: 'تحليلات في الوقت الفعلي',
    f4Desc: 'احصل على رؤى فورية مع لوحات معلومات قابلة للتخصيص وتقارير شاملة.',
    f5Title: 'الوصول عبر الهاتف المحمول',
    f5Desc: 'يمكن للفنيين الوصول إلى أوامر العمل وتحديث الحالة وتسجيل الوقت من أي مكان.',
    f6Title: 'إدارة أوامر العمل',
    f6Desc: 'إنشاء وتعيين وتتبع أوامر العمل مع مستويات الأولوية وسير العمل الآلي.',
    useCasesTitle: 'نتائج حقيقية عبر الصناعات',
    useCasesSubtitle: 'انظر كيف تحول الشركات عمليات الصيانة',
    challenge: 'التحدي',
    solution: 'الحل',
    result: 'النتيجة',
    uc1Industry: 'التصنيع',
    uc1Challenge: 'توقف غير مخطط للمعدات يكلف 50,000 دولار في الساعة',
    uc1Solution: 'تنفيذ جداول صيانة تنبؤية',
    uc1Result: 'انخفاض 35% في وقت التوقف، توفير سنوي بقيمة مليوني دولار',
    uc2Industry: 'إدارة المرافق',
    uc2Challenge: 'أوامر عمل ورقية يدوية تسبب تأخيرات',
    uc2Solution: 'نظام أوامر عمل رقمي مع تطبيق جوال',
    uc2Result: 'أوقات استجابة أسرع بنسبة 60%، تخفيض التكاليف بنسبة 40%',
    uc3Industry: 'الرعاية الصحية',
    uc3Challenge: 'تتبع امتثال المعدات والسلامة',
    uc3Solution: 'تتبع الامتثال الآلي والتنبيهات',
    uc3Result: 'امتثال تنظيمي 100%، صفر حوادث أمنية',
    uc4Industry: 'الضيافة والفنادق',
    uc4Challenge: 'إدارة طلبات الصيانة عبر مئات الغرف دون إزعاج النزلاء',
    uc4Solution: 'تتبع الأصول على مستوى الغرفة مع جدولة الأولويات وتوزيع الفنيين في الوقت الفعلي',
    uc4Result: 'استجابة أسرع بنسبة 50% لطلبات النزلاء وتحسن ملحوظ في مؤشرات الرضا',
    pricingTitle: 'اختر خطتك',
    pricingSubtitle: 'فاتورة شهرية أو سنوية • إلغاء في أي وقت',
    monthly: 'شهري',
    annual: 'سنوي',
    save10: 'وفر 10%',
    custom: 'مخصص',
    perMonth: '/شهر',
    billedAnnually: 'يُفوتر سنويًا',
    getStarted: 'ابدأ الآن',
    mostPopular: 'الأكثر شيوعًا',
    contactPricing: 'تواصل معنا للحصول على معلومات الأسعار.',
    getInTouch: 'تواصل معنا',
    ctaTitle: 'هل أنت مستعد لتحويل عمليات الصيانة الخاصة بك؟',
    ctaSubtitle: 'انضم إلى أكثر من 500 شركة تستخدم نظام إدارة الصيانة لخفض التكاليف وتحسين الكفاءة',
  },

  chatbotPage: {
    badge: 'دعم العملاء بالذكاء الاصطناعي',
    heroTitle: 'روبوت محادثة ذكي يفهم عملاءك',
    heroSubtitle: 'انشر روبوتات محادثة مدعومة بالذكاء الاصطناعي توفر دعم عملاء على مدار الساعة وتجيب على الأسئلة فورًا وتحوّل المحادثة تلقائيًا إلى وكلاء بشريين عند الحاجة.',
    tryItFree: 'جربه مجانًا',
    seeDemo: 'شاهد العرض التوضيحي',
    watchWalkthrough: 'مشاهدة العرض التوضيحي',
    videoSectionBadge: 'جولة تفصيلية بالمنتج',
    videoSectionTitle: 'شاهد mwbTechs Chatbot في العمل',
    videoSectionSubtitle: 'شاهد العرض التوضيحي الكامل وتعرّف على كيفية تعامل الروبوت مع محادثات العملاء الحقيقية.',
    benefitsTitle: 'لماذا تحب الشركات روبوت المحادثة الذكي الخاص بنا',
    b1Label: 'التوفر',
    b1Desc: 'لا تفوّت أي استفسار من العملاء',
    b2Label: 'معدل الأتمتة',
    b2Desc: 'معالجة معظم الاستفسارات تلقائيًا',
    b3Label: 'وقت الاستجابة',
    b3Desc: 'إجابات فورية، عملاء سعداء',
    b4Label: 'تخفيض التكاليف',
    b4Desc: 'تقليل تكاليف الدعم بشكل كبير',
    featuresTitle: 'ميزات قوية لدعم العملاء الحديث',
    featuresSubtitle: 'كل ما تحتاجه لتقديم تجربة عملاء استثنائية',
    f1Title: 'ذكاء اصطناعي متقدم',
    f1Desc: 'تقنية معالجة اللغة الطبيعية المتقدمة تفهم السياق والنية وتوفر ردودًا دقيقة تشبه الإنسان.',
    f2Title: 'دعم متعدد اللغات',
    f2Desc: 'التواصل مع العملاء بأكثر من 50 لغة مع الترجمة التلقائية.',
    f3Title: 'تدريب فوري',
    f3Desc: 'دّرب روبوت المحادثة على المستندات والمواقع والأسئلة الشائعة في دقائق.',
    f4Title: 'تحليلات المحادثة',
    f4Desc: 'تتبع المقاييس وتحديد الاتجاهات والتحسين المستمر لتجربة العملاء.',
    f5Title: 'تكامل سهل',
    f5Desc: 'كود تضمين بسيط لإضافة الشات بوت إلى موقعك أو تطبيقك أو منصتك في دقائق.',
    f6Title: 'دعم متعدد القنوات',
    f6Desc: 'انشر على الموقع الإلكتروني، التطبيق المحمول، واتساب، فيسبوك ماسنجر، وأكثر.',
    stepsTitle: 'ابدأ في 3 خطوات بسيطة',
    step1Title: 'دّرب روبوت المحادثة',
    step1Desc: 'حمّل المستندات أو أضف عناوين URL للمواقع أو الصق الأسئلة الشائعة. يتعلم الذكاء الاصطناعي المحتوى الخاص بك فورًا.',
    step2Title: 'خصص المظهر',
    step2Desc: 'طابق علامتك التجارية بألوان مخصصة وشعار ورسائل ترحيب.',
    step3Title: 'انشر في أي مكان',
    step3Desc: 'أضف كود التضمين إلى موقعك وانطلق في دقائق!',
    pricingTitle: 'أسعار بسيطة وشفافة',
    pricingSubtitle: 'فاتورة شهرية أو سنوية • إلغاء في أي وقت',
    monthly: 'شهري',
    annual: 'سنوي',
    save10: 'وفر 10%',
    custom: 'مخصص',
    perMonth: '/شهر',
    billedAnnually: 'يُفوتر سنويًا',
    getStarted: 'ابدأ الآن',
    mostPopular: 'الأكثر شيوعًا',
    contactPricing: 'تواصل معنا للحصول على معلومات الأسعار.',
    getInTouch: 'تواصل معنا',
    startFreeTrial: 'ابدأ الآن',
    planFeatMessages: '{{count}} رسالة / شهر',
    planFeatDocsUnlimited: 'مستندات غير محدودة / روبوت',
    planFeatDocs: '{{count}} مستند / روبوت',
    planFeatAgentsUnlimited: 'وكلاء مباشرون غير محدودون',
    planFeatAgents: 'وكيل مباشر واحد مشمول',
    planFeatAgentsPlural: '{{count}} وكلاء مباشرون مشمولون',
    planFeatChannels: 'واتساب وإنستغرام وفيسبوك',
    liveAgentBadge: 'دعم الوكيل المباشر',
    liveAgentTitle: 'الذكاء الاصطناعي يتولى أولًا. البشر يتدخلون عند الحاجة.',
    liveAgentSubtitle: 'عندما يصل الذكاء الاصطناعي إلى حدوده، ينضم وكيل حقيقي إلى المحادثة — فورًا وبالسياق الكامل.',
    liveAgentDesc: 'يراقب روبوت المحادثة كل محادثة في الوقت الفعلي. عندما يعجز عن حل مشكلة أو يطلب الزائر مساعدة بشرية، يُشغّل تلقائيًا تحويل المحادثة إلى فريق الوكلاء. يرى الوكلاء سجل المحادثة الكامل، ولن يضطر العملاء أبدًا إلى تكرار أنفسهم.',
    liveAgentB1: 'تصعيد تلقائي عندما يعجز الذكاء الاصطناعي عن الحل',
    liveAgentB2: 'يرى الوكلاء سجل المحادثة الكامل',
    liveAgentB3: 'صندوق وارد للوكيل في الوقت الفعلي لإدارة المحادثات المباشرة',
    liveAgentB4: 'تسليم سلس — بدون أي انقطاع للزوار',
    ctaTitle: 'هل أنت مستعد لأتمتة دعم العملاء الخاص بك؟',
    ctaSubtitle: 'انضم إلى الشركات التي تستخدم روبوتات الذكاء الاصطناعي والوكلاء البشريين لإسعاد العملاء',
    seeInAction: 'شاهده في العمل',
  },

  sfmsPage: {
    badge: 'إدارة المرافق الرياضية',
    heroTitle: 'كل المواقع والأعضاء وسجلات الحجز في نظام واحد',
    heroSubtitle: 'يجمع SFMS سجلات الحجز واشتراكات الأكاديمية والعضويات والفعاليات والمعدات في مكان واحد، مع صلاحيات وصول حسب الدور في جميع مواقعك.',
    requestDemo: 'اطلب عرضاً توضيحياً',
    seeDashboard: 'شاهد لوحة التحكم',
    talkToSales: 'تحدث إلى فريق المبيعات',
    highlightsTitle: 'مصمم للمرافق بجميع أحجامها',
    h1: 'سجلات حجز لكل ملعب وصالة',
    h2: 'اشتراكات الأكاديمية والعضويات في مكان واحد',
    h3: 'عدة مواقع تحت حساب واحد',
    h4: 'صلاحيات وصول حسب الدور لكل موظف',
    previewTitle: 'شاهد SFMS أثناء العمل',
    previewSubtitle: 'نظرة على لوحة التحكم التي يعمل فريقك عليها كل يوم',
    previewCaption: 'SFMS — لوحة التحكم',
    previewAlt: 'لوحة تحكم SFMS',
    previewPlaceholder: 'ضع صورة لوحة التحكم هنا',
    featuresTitle: 'كل ما يحتاجه مرفقك في مكان واحد',
    featuresSubtitle: 'من سجلات الحجز والاشتراكات إلى تقارير الاستخدام',
    f1Title: 'سجلات الحجز',
    f1Desc: 'سجّل وتابع كل حجز في ملاعبك وصالاتك، مع الاحتفاظ بالسجل الكامل لكل مساحة.',
    f2Title: 'اشتراكات الأكاديمية',
    f2Desc: 'سجّل الأعضاء في برامج الأكاديمية واحتفظ بسجل محدَّث للفصول والتجديدات والحضور.',
    f3Title: 'إدارة العضويات',
    f3Desc: 'أنشئ خطط العضوية وحافظ على تنظيم فترات الصلاحية والتجديدات والاستحقاقات.',
    f4Title: 'الفعاليات',
    f4Desc: 'نظّم البطولات والمباريات الودية والفعاليات الخاصة، واعرضها جنباً إلى جنب مع حجوزاتك المعتادة.',
    f5Title: 'المخزون',
    f5Desc: 'احتفظ بمخزون مبسّط للمعدات والمستلزمات، مع مستويات المخزون وحركته في كل موقع.',
    f6Title: 'الأدوار والصلاحيات',
    f6Desc: 'يمنح التحكم بالوصول حسب الدور كل موظف الشاشات والسجلات التي يحتاجها عمله بالضبط.',
    f7Title: 'تعدد المواقع',
    f7Desc: 'أدِر عدة مواقع من حساب واحد، لكل موقع مساحاته وموظفوه وسجلاته.',
    f8Title: 'التقارير ونسب الاستخدام',
    f8Desc: 'اعرف كيف تُستخدم كل مساحة خلال الأسبوع وخطّط ساعات العمل والكوادر وفق الطلب الفعلي.',
    ctaTitle: 'هل أنت مستعد لإدارة مرفقك من نظام واحد؟',
    ctaSubtitle: 'اكتشف كيف يجمع SFMS سجلات الحجز والاشتراكات والمواقع في مكان واحد.',
  },

  gmsPage: {
    badge: 'إدارة الصالات الرياضية',
    heroTitle: 'أدِر صالتك الرياضية بلا أوراق',
    heroSubtitle: 'يتولى GMS العضويات وتسجيل الدخول وجداول الحصص وفرق المدربين في مكان واحد، ليمنح فريقك وقتاً أكبر للأعضاء بدلاً من جداول البيانات.',
    requestDemo: 'اطلب عرضاً توضيحياً',
    seeDashboard: 'شاهد لوحة التحكم',
    talkToSales: 'تحدث إلى فريق المبيعات',
    highlightsTitle: 'مناسب للاستوديوهات والصالات والسلاسل',
    h1: 'ملفات الأعضاء والخطط والتجديدات',
    h2: 'تسجيل دخول سريع من الاستقبال أو ذاتياً',
    h3: 'جداول الحصص الجماعية والتدريب الشخصي',
    h4: 'جداول المدربين وتوزيع الأعضاء عليهم',
    previewTitle: 'شاهد GMS أثناء العمل',
    previewSubtitle: 'نظرة على لوحة التحكم التي يعمل فريقك عليها كل يوم',
    previewCaption: 'GMS — لوحة التحكم',
    previewAlt: 'لوحة تحكم GMS',
    previewPlaceholder: 'ضع صورة لوحة التحكم هنا',
    featuresTitle: 'كل ما تحتاجه لإدارة صالتك الرياضية',
    featuresSubtitle: 'العضويات والحصص والموظفون والتقارير في منصة واحدة',
    f1Title: 'خطط العضوية',
    f1Desc: 'أنشئ خططاً شهرية وسنوية وبالحصة، وتحكّم في التجديدات والتجميد والإلغاء.',
    f2Title: 'تسجيل الدخول والوصول',
    f2Desc: 'سجّل دخول الأعضاء من الاستقبال أو من جهاز خدمة ذاتية، واكتشف العضويات المنتهية قبل وصولهم.',
    f3Title: 'جدولة الحصص',
    f3Desc: 'انشر الحصص الجماعية مع حدود للسعة وقوائم انتظار وحجز ذاتي للأعضاء.',
    f4Title: 'إدارة المدربين',
    f4Desc: 'أسنِد المدربين إلى الحصص والجلسات الشخصية واجعل كل جدول واضحاً لكامل الفريق.',
    f5Title: 'الفواتير والمدفوعات',
    f5Desc: 'حصّل المدفوعات المتكررة والفردية وتابع المبالغ المستحقة على كل عضو.',
    f6Title: 'تحليلات الأعضاء',
    f6Desc: 'تابع الحضور والاستمرارية وتوزيع الخطط عبر لوحات معلومات مخصصة لمشغلي الصالات.',
    ctaTitle: 'هل أنت مستعد لتحديث إدارة صالتك؟',
    ctaSubtitle: 'اجمع العضويات والحصص والمدفوعات في نظام واحد يستخدمه فريقك بالكامل.',
  },

  pricingPage: {
    heroTitle1: 'بسيط،',
    heroTitle2: 'أسعار شفافة',
    heroSubtitle: 'اختر الخطة المثالية لأعمالك.',
    cmmsPlans: 'خطط نظام إدارة الصيانة',
    chatbotPlans: 'خطط روبوت المحادثة الذكي',
    monthly: 'شهري',
    annual: 'سنوي',
    save10: 'وفر 10%',
    custom: 'مخصص',
    perMonth: '/شهر',
    billedAnnually: 'يُفوتر سنويًا',
    mostPopular: 'الأكثر شيوعًا',
    startFreeTrial: 'ابدأ الآن',
    contactPricing: 'تواصل معنا للحصول على معلومات الأسعار.',
    faqTitle: 'الأسئلة الشائعة',
    faq1Q: 'هل يمكنني تغيير الخطة في أي وقت؟',
    faq1A: 'نعم! يمكنك الترقية أو التخفيض في أي وقت. تسري التغييرات فورًا.',
    faq2Q: 'ما طرق الدفع التي تقبلونها؟',
    faq2A: 'نقبل جميع بطاقات الائتمان الرئيسية (فيزا، ماستركارد، أمريكان إكسبريس) وباي بال والتحويلات المصرفية للخطط السنوية.',
    faq3Q: 'هل تقدمون تجربة مجانية؟',
    faq3A: 'لا نقدم تجربة مجانية. اطلب عرضاً توضيحياً وسنشرح لك المنصة قبل أن تختار خطتك.',
    faq4Q: 'هل يمكنني رؤية المنصة قبل الشراء؟',
    faq4A: 'نعم. اطلب عرضاً توضيحياً وسنقدم لك شرحاً مبنياً على طريقة استخدامك المتوقعة للنظام.',
    faq5Q: 'هل تقدمون استردادًا للمبالغ؟',
    faq5A: 'نعم، نقدم ضمان استرداد المبالغ خلال 30 يومًا على جميع الخطط.',
    faq6Q: 'هل يمكنني الحصول على خطة مخصصة؟',
    faq6A: 'بالتأكيد! تواصل مع فريق المبيعات للحصول على حلول مؤسسية مخصصة تناسب احتياجاتك.',
    ctaTitle: 'هل أنت مستعد للبدء؟',
    ctaSubtitle: 'اطلب عرضاً توضيحياً وسنساعدك في اختيار الخطة المناسبة.',
    contactSales: 'تواصل مع المبيعات',
  },

  docsPage: {
    title: 'التوثيق',
    subtitle: 'كل ما تحتاجه للاستفادة القصوى من mwbTechs',
    searchPlaceholder: 'ابحث في التوثيق...',
    s1Title: 'البدء',
    s1Desc: 'أدلة البدء السريع وموارد التأهيل',
    s1l1: 'التثبيت',
    s1l2: 'الخطوات الأولى',
    s1l3: 'الإعداد الأساسي',
    s1l4: 'الدروس التعليمية',
    s2Title: 'دليل روبوت المحادثة',
    s2Desc: 'إنشاء وتكوين وتضمين روبوت المحادثة الذكي',
    s2l1: 'إنشاء روبوت محادثة',
    s2l2: 'قاعدة المعرفة والاسترجاع',
    s2l3: 'التكامل مع الموقع',
    s2l4: 'التكامل مع تطبيق الجوال',
    s2l5: 'تكامل REST API',
    s2l6: 'إعداد قناة واتساب',
    s2l7: 'إعداد قناة ماسنجر',
    s2l8: 'إعداد قناة إنستغرام',
    s3Title: 'دليل نظام إدارة الصيانة',
    s3Desc: 'إعداد وإدارة عمليات الصيانة',
    s3l1: 'البدء',
    s3l2: 'إدارة الأصول',
    s3l3: 'أوامر العمل',
    s3l4: 'الصيانة الوقائية',
    s3l5: 'الفريق والصلاحيات',
    s4Title: 'الدروس المصورة',
    s4Desc: 'شروحات مرئية خطوة بخطوة',
    s4l1: 'جولة سريعة',
    s4l2: 'الميزات المتقدمة',
    s4l3: 'أفضل الممارسات',
    s4l4: 'استكشاف الأخطاء',
    needHelpTitle: 'هل تحتاج إلى مزيد من المساعدة؟',
    needHelpSubtitle: 'فريق الدعم لدينا هنا لمساعدتك',
    visitHelp: 'زيارة مركز المساعدة',
    contactSupport: 'التواصل مع الدعم',
  },

  dtPage: {
    badge: 'الاستشارات الاستراتيجية',
    heroTitle: 'التحول الرقمي الذي يحقق نتائج حقيقية',
    heroSubtitle: 'تنقل التغيير الرقمي بثقة. نساعد المؤسسات على تحديث العمليات وتبني التكنولوجيا وتحقيق نمو مستدام.',
    scheduleConsultation: 'جدولة استشارة',
    ourApproach: 'نهجنا',
    stat1Label: 'تحولات مكتملة',
    stat2Label: 'رضا العملاء',
    stat3Label: 'متوسط القيمة المضافة',
    stat4Label: 'سنوات الخبرة',
    servicesTitle: 'خدمات شاملة للتحول الرقمي',
    servicesSubtitle: 'دعم متكامل لرحلتك الرقمية',
    keyDeliverables: 'المخرجات الرئيسية:',
    s1Title: 'الاستراتيجية والتقييم',
    s1Desc: 'تقييم الوضع الراهن وتحديد الفرص وتطوير خارطة طريق شاملة للتحول الرقمي.',
    s1d1: 'تقييم النضج الرقمي',
    s1d2: 'تحليل الفجوات التقنية',
    s1d3: 'خارطة الطريق الاستراتيجية',
    s1d4: 'توقعات العائد على الاستثمار',
    s2Title: 'تحسين العمليات',
    s2Desc: 'تبسيط العمليات وإزالة عدم الكفاءة وأتمتة سير العمل اليدوي.',
    s2d1: 'رسم خرائط العمليات',
    s2d2: 'فرص الأتمتة',
    s2d3: 'تصميم سير العمل',
    s2d4: 'إطار مؤشرات الأداء',
    s3Title: 'تطبيق التكنولوجيا',
    s3Desc: 'نشر الحلول الحديثة ودمج الأنظمة والانتقال إلى البنية التحتية السحابية.',
    s3d1: 'اختيار النظام',
    s3d2: 'تخطيط التكامل',
    s3d3: 'الهجرة إلى السحابة',
    s3d4: 'برامج التدريب',
    methodologyTitle: 'منهجيتنا المثبتة',
    methodologySubtitle: 'نهج منظم يحقق النتائج',
    p1Phase: '1. الاكتشاف',
    p1Duration: 'أسبوعان إلى 3 أسابيع',
    p1a1: 'مقابلات أصحاب المصلحة',
    p1a2: 'تحليل الوضع الراهن',
    p1a3: 'توافق الأهداف',
    p1a4: 'تحديد نقاط الضعف',
    p2Phase: '2. الاستراتيجية',
    p2Duration: '3 إلى 4 أسابيع',
    p2a1: 'خارطة الطريق الرقمية',
    p2a2: 'اختيار التكنولوجيا',
    p2a3: 'خطة إدارة التغيير',
    p2a4: 'الميزانية والجدول الزمني',
    p3Phase: '3. التنفيذ',
    p3Duration: '8 إلى 12 أسبوعًا',
    p3a1: 'نشر الحل',
    p3a2: 'تكامل الأنظمة',
    p3a3: 'نقل البيانات',
    p3a4: 'تدريب المستخدمين',
    p4Phase: '4. التحسين',
    p4Duration: 'مستمر',
    p4a1: 'مراقبة الأداء',
    p4a2: 'التحسين المستمر',
    p4a3: 'دعم المستخدمين',
    p4a4: 'تتبع العائد على الاستثمار',
    caseStudiesTitle: 'قصص النجاح',
    caseStudiesSubtitle: 'تحولات حقيقية، نتائج قابلة للقياس',
    challenge: 'التحدي',
    solution: 'الحل',
    results: 'النتائج',
    cs1Company: 'Manufacturing Corp',
    cs1Industry: 'التصنيع',
    cs1Challenge: 'عمليات ورقية تسبب تأخيرات وأخطاء',
    cs1Solution: 'أتمتة سير عمل رقمي وتكامل إنترنت الأشياء',
    cs1r1: 'معالجة الطلبات أسرع بنسبة 70%',
    cs1r2: 'انخفاض الأخطاء بنسبة 90%',
    cs1r3: 'توفير سنوي بقيمة 1.5 مليون دولار',
    cs1r4: 'زيادة الإنتاجية بنسبة 40%',
    cs2Company: 'Retail Chain',
    cs2Industry: 'التجزئة',
    cs2Challenge: 'أنظمة منفصلة وضعف رؤى العملاء',
    cs2Solution: 'منصة تجارية موحدة ولوحة تحليلات',
    cs2r1: 'رؤية 360° للعميل',
    cs2r2: 'زيادة المبيعات بنسبة 25%',
    cs2r3: 'مخزون في الوقت الفعلي',
    cs2r4: 'سداد أسرع بنسبة 50%',
    cs3Company: 'Financial Services',
    cs3Industry: 'المالية',
    cs3Challenge: 'أنظمة قديمة تحد من الابتكار والمرونة',
    cs3Solution: 'الهجرة إلى السحابة وبنية API-first',
    cs3r1: 'سرعة نشر أعلى 10 مرات',
    cs3r2: 'تخفيض التكاليف بنسبة 60%',
    cs3r3: 'صفر توقف',
    cs3r4: 'بنية تحتية قابلة للتوسع',
    ctaTitle: 'هل أنت مستعد لتحويل أعمالك؟',
    ctaSubtitle: 'جدول استشارة مجانية لمناقشة رحلة التحول الرقمي الخاصة بك',
    scheduleFreeConsultation: 'جدولة استشارة مجانية',
    expertConsultants: 'خبراء استشاريين',
    successRate: 'معدل النجاح',
    avgValueCreated: 'متوسط القيمة المضافة',
  },

  cdPage: {
    badge: 'التطوير المخصص',
    heroTitle: 'بناء برمجيات تنمو مع أعمالك',
    heroSubtitle: 'فريق تطوير خبير جاهز لتحويل رؤيتك إلى واقع. من MVP إلى حلول المؤسسات.',
    requestQuote: 'طلب عرض أسعار',
    viewPortfolio: 'عرض المحفظة',
    stat1Title: 'أكثر من 200 مشروع مُنجز',
    stat1Sub: 'عبر أكثر من 15 صناعة',
    stat2Title: 'رضا العملاء 98%',
    stat2Sub: 'بناءً على أكثر من 150 مراجعة',
    stat3Title: 'متوسط 4 أسابيع للبدء',
    stat3Sub: 'من العقد إلى التطوير',
    servicesTitle: 'خدمات تطوير شاملة',
    servicesSubtitle: 'تطوير متكامل بتقنيات حديثة',
    s1Title: 'تطبيقات الويب',
    s1Desc: 'تطبيقات ويب مخصصة مبنية بأطر عمل حديثة للقابلية للتوسع والأداء.',
    s2Title: 'تطوير تطبيقات الجوال',
    s2Desc: 'تطبيقات iOS/Android أصلية أو حلول متعددة المنصات لأقصى قدر من الوصول.',
    s3Title: 'الحلول السحابية',
    s3Desc: 'بنية سحابية قابلة للتوسع وخدمات الهجرة للبنية التحتية الحديثة.',
    s4Title: 'تطوير واجهات برمجة التطبيقات',
    s4Desc: 'واجهات RESTful وGraphQL لتكامل سلس بين الأنظمة.',
    s5Title: 'الأمن والامتثال',
    s5Desc: 'أمان على مستوى المؤسسات مع معايير الامتثال المدمجة.',
    s6Title: 'تحسين الأداء',
    s6Desc: 'تسريع التطبيقات الحالية وتحسينها للتوسع.',
    processTitle: 'عملية التطوير لدينا',
    processSubtitle: 'منهجية Agile مع نتائج مثبتة',
    pr1Step: 'الاكتشاف',
    pr1Desc: 'فهم المتطلبات والأهداف والقيود التقنية',
    pr1Duration: 'أسبوع إلى أسبوعين',
    pr1d1: 'وثيقة المتطلبات',
    pr1d2: 'المواصفات التقنية',
    pr1d3: 'الجدول الزمني للمشروع',
    pr1d4: 'تقدير التكلفة',
    pr2Step: 'التصميم',
    pr2Desc: 'إنشاء البنية وتصاميم UX/UI وخارطة طريق التطوير',
    pr2Duration: 'أسبوعان إلى 3 أسابيع',
    pr2d1: 'بنية النظام',
    pr2d2: 'نماذج UI/UX',
    pr2d3: 'مخطط قاعدة البيانات',
    pr2d4: 'تصميم API',
    pr3Step: 'التطوير',
    pr3Desc: 'بناء الحل بدورات Agile وتكامل مستمر',
    pr3Duration: '8 إلى 16 أسبوعًا',
    pr3d1: 'برمجيات تعمل',
    pr3d2: 'مراجعات الكود',
    pr3d3: 'عروض الدورات',
    pr3d4: 'التوثيق',
    pr4Step: 'الاختبار',
    pr4Desc: 'ضمان جودة شامل واختبار أمني وتحسين الأداء',
    pr4Duration: 'أسبوعان إلى 3 أسابيع',
    pr4d1: 'تقارير الاختبار',
    pr4d2: 'إصلاح الأخطاء',
    pr4d3: 'مقاييس الأداء',
    pr4d4: 'تدقيق الأمان',
    pr5Step: 'النشر',
    pr5Desc: 'النشر في الإنتاج مع إعداد المراقبة والدعم',
    pr5Duration: 'أسبوع واحد',
    pr5d1: 'تطبيق مباشر',
    pr5d2: 'وثائق النشر',
    pr5d3: 'إعداد المراقبة',
    pr5d4: 'التدريب',
    pr6Step: 'الدعم',
    pr6Desc: 'صيانة مستمرة وتحديثات وتحسينات للميزات',
    pr6Duration: 'مستمر',
    pr6d1: 'إصلاح الأخطاء',
    pr6d2: 'التحديثات',
    pr6d3: 'ميزات جديدة',
    pr6d4: 'دعم على مدار الساعة',
    portfolioTitle: 'مشاريع حديثة',
    portfolioSubtitle: 'حلول حقيقية بنيناها لأعمال حقيقية',
    pf1Title: 'منصة التجارة الإلكترونية',
    pf1Desc: 'بنينا سوقًا قابلًا للتوسع يتعامل مع أكثر من 100,000 معاملة يومية',
    pf2Title: 'بوابة الرعاية الصحية',
    pf2Desc: 'نظام إدارة مرضى متوافق مع HIPAA',
    pf3Title: 'تطبيق FinTech للجوال',
    pf3Desc: 'تطبيق مصرفي بالهاتف مع مصادقة بيومترية',
    investmentTitle: 'نطاقات الاستثمار',
    investmentSubtitle: 'أسعار شفافة لكل حجم مشروع',
    pl1Name: 'تطوير MVP',
    pl1Desc: 'مثالي للشركات الناشئة وإثبات المفاهيم',
    pl2Name: 'منتج كامل',
    pl2Desc: 'حل متكامل للأعمال المتنامية',
    pl3Name: 'المؤسسات',
    pl3Desc: 'حلول واسعة النطاق مع فريق مخصص',
    mostPopular: 'الأكثر شيوعًا',
    getQuote: 'احصل على عرض أسعار',
    ctaTitle: 'هل أنت مستعد لبناء حلك المخصص؟',
    ctaSubtitle: 'لنناقش مشروعك ونبتكر شيئًا رائعًا معًا',
    requestFreeQuote: 'طلب عرض أسعار مجاني',
  },

  aboutPage: {
    heroTitle1: 'تحويل الأعمال من خلال',
    heroTitle2: 'الابتكار',
    heroSubtitle: 'نحن في مهمة لمساعدة الشركات على تحديث عملياتها بحلول برمجية ذكية تحقق نتائج حقيقية.',
    getInTouch: 'تواصل معنا',
    startFreeTrial: 'ابدأ الآن',
    stat1Label: 'عملاء حول العالم',
    stat2Label: 'مستخدم نشط',
    stat3Label: 'رضا العملاء',
    stat4Label: 'دعم متاح',
    storyTitle: 'قصتنا',
    storyP1: 'تأسست mwbTechs في عام 2018 بملاحظة بسيطة: كانت الشركات تعاني من أنظمة إدارة صيانة قديمة تعيق الإنتاجية وتزيد التكاليف.',
    storyP2: 'رأى مؤسسونا، وهم فريق من المهندسين وقادة الأعمال بخبرة مشتركة تمتد لعقود، فرصة لإحداث ثورة في طريقة إدارة الشركات لعملياتها. بنينا أول حل لنظام إدارة الصيانة مع التركيز على البساطة والقوة وتجربة المستخدم.',
    storyP3: 'اليوم، نخدم أكثر من 2,000 شركة حول العالم، من الفرق الصغيرة إلى شركات Fortune 500. لقد وسّعنا عروضنا لتشمل روبوتات المحادثة بالذكاء الاصطناعي واستشارات التحول الرقمي وخدمات التطوير المخصص.',
    storyP4: 'لكن مهمتنا الأساسية تبقى كما هي: مساعدة الشركات على العمل بكفاءة أكبر من خلال حلول تقنية مبتكرة.',
    countriesServed: 'دولة نخدمها',
    industryAwards: 'جائزة صناعية',
    teamMembers: 'عضو في الفريق',
    yoyGrowth: 'نمو سنوي',
    valuesTitle: 'قيمنا',
    valuesSubtitle: 'المبادئ التي توجه كل ما نفعله',
    v1Title: 'الابتكار أولاً',
    v1Desc: 'نحن نتجاوز الحدود باستمرار لتقديم حلول متطورة تخلق قيمة تجارية حقيقية.',
    v2Title: 'نجاح العملاء',
    v2Desc: 'نجاحك هو نجاحنا. نحن ملتزمون بمساعدتك على تحقيق أهدافك.',
    v3Title: 'التعاون',
    v3Desc: 'نؤمن بقوة العمل الجماعي، داخلياً ومع عملائنا.',
    v4Title: 'التميز',
    v4Desc: 'نحافظ على أعلى المعايير في كل ما نفعله، من الكود إلى خدمة العملاء.',
    teamTitle: 'فريق القيادة',
    teamSubtitle: 'قادة ذوو خبرة شغوفون بالابتكار',
    timelineTitle: 'مسيرتنا',
    timelineSubtitle: 'المعالم الرئيسية في قصة نمونا',
    m1Event: 'تأسيس الشركة',
    m1Desc: 'بدأنا برؤية لتحويل إدارة الصيانة',
    m2Event: 'أول 100 عميل',
    m2Desc: 'بلغنا معلم المائة عميل سعيد عبر 10 صناعات',
    m3Event: 'تمويل السلسلة أ',
    m3Desc: 'جمعنا 10 ملايين دولار لتسريع تطوير المنتج',
    m4Event: 'إطلاق روبوت المحادثة الذكي',
    m4Desc: 'أطلقنا حل دعم العملاء الثوري المدعوم بالذكاء الاصطناعي',
    m5Event: 'التوسع العالمي',
    m5Desc: 'توسعنا في أوروبا وآسيا والمحيط الهادئ',
    m6Event: 'أكثر من 1,000 عميل',
    m6Desc: 'تخطينا معلم 1,000 عميل بمعدل رضا 98%',
    m7Event: 'الاعتراف الصناعي',
    m7Desc: 'صُنّفنا قائداً في المربع السحري لـ Gartner',
    m8Event: 'نمو مستمر',
    m8Desc: 'نخدم أكثر من 2,000 شركة حول العالم مع أكثر من 50,000 مستخدم نشط',
    ctaTitle: 'انضم إلى رحلتنا',
    ctaSubtitle: 'كن جزءاً من مستقبل العمليات التجارية',
    contactUs: 'اتصل بنا',
  },
  chatbotDocs: {
    breadcrumb: 'التوثيق',
    title: 'دليل دمج الشات بوت',
    heroSubtitle: 'أنشئ شات بوت الذكاء الاصطناعي الخاص بك، وبنِ قاعدة معرفته، وضمّنه في موقعك الإلكتروني أو تطبيقك المحمول — خطوة بخطوة.',
    onThisPage: 'في هذه الصفحة',
    toc_create: 'إنشاء شات بوت',
    toc_kb: 'قاعدة المعرفة وRAG',
    toc_website: 'دمج الموقع الإلكتروني',
    toc_mobile: 'دمج التطبيق المحمول',
    toc_api: 'دمج REST API',
    toc_whatsapp: 'إعداد قناة واتساب',
    toc_messenger: 'إعداد قناة ماسنجر',
    toc_instagram: 'إعداد قناة إنستغرام',
    s1_title: 'إنشاء شات بوت',
    s1_subtitle: 'أعدّ شات بوتك في بوابة العملاء في دقائق.',
    s1_step1: 'سجّل الدخول إلى بوابة العملاء وانتقل إلى قسم الشات بوت من الشريط الجانبي.',
    s1_step2: 'انقر على «إنشاء شات بوت جديد» وأدخل التفاصيل الأساسية.',
    s1_step3: 'قم بتهيئة إعدادات المظهر والسلوك:',
    s1_field: 'الحقل',
    s1_fieldDesc: 'الوصف',
    s1_fname: 'الاسم',
    s1_fnameDesc: 'التسمية الداخلية لهذا الشات بوت',
    s1_fBotName: 'اسم البوت',
    s1_fBotNameDesc: 'الاسم المعروض للزوار',
    s1_fWelcome: 'رسالة الترحيب',
    s1_fWelcomeDesc: 'أول رسالة يراها الزائر عند فتح الدردشة',
    s1_fPrompt: 'System Prompt',
    s1_fPromptDesc: 'تعليمات تحدد شخصية الذكاء الاصطناعي ونطاقه',
    s1_fColor: 'اللون الأساسي',
    s1_fColorDesc: 'لون التمييز لأداة الدردشة (رمز hex)',
    s1_fPosition: 'الموضع',
    s1_fPositionDesc: 'مكان ظهور الأداة: أسفل اليمين أو أسفل اليسار',
    s1_note: 'بعد الحفظ، سيُعرض عليك معرّف الشات بوت وكود التضمين. احتفظ بمعرّف الشات بوت — ستحتاجه في خطوات الدمج أدناه.',
    s2_title: 'قاعدة المعرفة وRAG',
    s2_subtitle: 'زوّد شات بوتك بالمستندات وصفحات الويب وبيانات API المباشرة.',
    s2_intro: 'افتح نافذة قاعدة المعرفة (أيقونة الترس ← قاعدة المعرفة). يمكنك إضافة المحتوى من ثلاثة مصادر:',
    s2_docs: 'المستندات المُحمَّلة',
    s2_docsDesc: 'حمّل ملفات PDF أو DOCX أو TXT. تستخرج المنصة النص وتقسّمه إلى أجزاء وتخزّن تضمينات المتجهات حتى يتمكن الذكاء الاصطناعي من استرداد المقاطع ذات الصلة.',
    s2_docsSupported: 'المدعوم: PDF، DOCX، TXT، HTML',
    s2_urls: 'روابط الموقع',
    s2_urlsDesc: 'الصق رابطاً وستقوم المنصة تلقائياً بالزحف إلى الصفحة وفهرستها. مفيد لصفحات المنتجات والأسئلة الشائعة والمدونات.',
    s2_apis: 'واجهات API الخارجية',
    s2_apisDesc: 'اربط واجهات REST API مباشرة (مثل مخزون متجرك الإلكتروني). عندما يطرح زائر سؤالاً ذا صلة، يستدعي الشات بوت واجهة API في الوقت الفعلي ويجيب من استجابة JSON الحديثة.',
    s2_configFields: 'حقول التهيئة',
    s2_afName: 'الاسم',
    s2_afNameDesc: 'تسمية قصيرة، مثل «بحث المنتجات»',
    s2_afDesc: 'الوصف',
    s2_afDescDesc: 'يخبر الذكاء الاصطناعي متى يستخدم هذه الواجهة، مثل: «استخدم عند سؤال الزائر عن المنتجات أو الأسعار»',
    s2_afEndpoint: 'رابط Endpoint',
    s2_afEndpointDesc: 'الرابط الكامل؛ أضف عنصراً نائباً {query} للبحث، أو احذفه لجلب القائمة الكاملة',
    s2_afAuthName: 'اسم رأس المصادقة',
    s2_afAuthNameDesc: 'اختياري — مثل X-Shopify-Access-Token',
    s2_afAuthValue: 'قيمة رأس المصادقة',
    s2_afAuthValueDesc: 'اختياري — مخزّن مشفراً بـ AES-256',
    s2_urlExamples: 'أمثلة على الروابط',
    s2_note: 'استخدم «اختبار وحفظ» للتحقق من إمكانية الوصول إلى Endpoint قبل الحفظ. حتى 5 واجهات API خارجية لكل شات بوت.',
    s3_title: 'دمج الموقع الإلكتروني',
    s3_subtitle: 'أضف أداة الدردشة إلى أي موقع بوسم script واحد.',
    s3_step1: 'انسخ معرّف الشات بوت من بوابة العملاء (مرئي على بطاقة الشات بوت أو في قسم التضمين).',
    s3_step2: 'الصق وسم script أدناه في صفحة HTML قبل وسم </body> مباشرة.',
    s3_step3: 'عدّل سمات data-* لتتوافق مع إعدادات شات بوتك.',
    s3_attrRef: 'مرجع السمات',
    s3_attrAttr: 'السمة',
    s3_attrRequired: 'مطلوب',
    s3_attrDesc: 'الوصف',
    s3_attr1Req: '✅ نعم',
    s3_attr1Desc: 'المعرّف الفريد لشات بوتك',
    s3_attr2Req: '✅ نعم',
    s3_attr2Desc: 'الرابط الأساسي لخادم الشات بوت',
    s3_attr3Req: 'اختياري',
    s3_attr3Desc: 'لون التمييز بكود hex (#007bff)',
    s3_attr4Req: 'اختياري',
    s3_attr4Desc: 'أسفل اليمين (افتراضي) أو أسفل اليسار',
    s3_attr5Req: 'اختياري',
    s3_attr5Desc: 'رسالة الافتتاح المعروضة للزائر',
    s3_attr6Req: 'اختياري',
    s3_attr6Desc: 'اسم العرض للمساعد الذكي',
    s4_title: 'دمج التطبيق المحمول',
    s4_subtitle: 'ضمّن أداة الدردشة في تطبيق React Native باستخدام WebView.',
    s4_step1: 'ثبّت حزمة WebView:',
    s4_step2: 'أنشئ مكوّن ChatbotWidget. استبدل YOUR_CHATBOT_ID وyour-platform.com بقيمك الخاصة.',
    s4_step3: 'أضف المكوّن في جذر تطبيقك (داخل موفر المصادقة ليظهر فقط عند تسجيل الدخول):',
    s4_platformNotes: 'ملاحظات المنصات',
    s4_pAndroid: 'محاكي Android',
    s4_pAndroidDesc: 'استخدم 10.0.2.2 بدلاً من localhost (يربط المحاكي 10.0.2.2 بجهازك)',
    s4_pDevice: 'جهاز حقيقي',
    s4_pDeviceDesc: 'استخدم عنوان IP الشبكة المحلية لجهازك (مثل 192.168.1.x) حتى يتمكن الجهاز من الوصول إلى خادم التطوير',
    s4_pIOS: 'محاكي iOS',
    s4_pIOSDesc: 'يعمل localhost مباشرةً',
    s4_pProd: 'الإنتاج',
    s4_pProdDesc: 'استخدم نطاق HTTPS الحقيقي — لا تغييرات مطلوبة',
    s5_title: 'دمج REST API',
    s5_subtitle: 'استدعِ واجهة Chat API مباشرةً من أي خادم أو تطبيق محمول أو واجهة مخصصة — دون الحاجة إلى الأداة.',
    s5_intro: 'يكشف كل شات بوت عن نفس نقطة نهاية REST. تُدعم طريقتان للمصادقة: مفتاح الأداة (رأس X-Widget-Key، آمن للاستخدام في المتصفح/الأداة) ومفتاح API سري (رأس Authorization: Bearer، للتكاملات الآمنة من جانب الخادم). ولّد مفتاح API من إعدادات الشات بوت في بوابة العملاء.',
    s5_auth: 'المصادقة',
    s5_authDesc: 'اختر الطريقة المناسبة: X-Widget-Key للأداة المضمّنة، أو Authorization: Bearer <api-key> للتكاملات المخصصة من جانب الخادم (ولّد المفتاح في إعدادات الشات بوت).',
    s5_sendMsg: 'إرسال رسالة',
    s5_reqHeaders: 'رؤوس الطلب',
    s5_reqBody: 'جسم الطلب (JSON)',
    s5_field: 'الحقل',
    s5_required: 'مطلوب',
    s5_fSessionIdDesc: 'معرّف المحادثة الفريد — أنشئ UUID لكل محادثة',
    s5_fMessageDesc: 'نص رسالة المستخدم',
    s5_fVisitorIdDesc: 'معرّف المستخدم/الزائر الداخلي',
    s5_fVisitorEmailDesc: 'بريد الزائر الإلكتروني — يُخزَّن في سجل المحادثة',
    s5_fVisitorNameDesc: 'اسم عرض الزائر',
    s5_fMediaUrlDesc: 'رابط ملف وسائط لإرفاقه بالرسالة (صورة، صوت، مستند)',
    s5_fChannelTypeDesc: '«WIDGET» (افتراضي) أو «WHATSAPP» — يحدد القناة المُرسِلة',
    s5_fChannelSenderIdDesc: 'معرّف المُرسِل عبر واتساب (wa_id) — مطلوب عند تعيين channelType على «WHATSAPP»',
    s5_codeExamples: 'أمثلة الكود',
    s5_response: 'الاستجابة',
    s5_endConv: 'إنهاء محادثة',
    s5_endConvDesc: 'استدعِ هذا عند إغلاق المستخدم للدردشة لوضع علامة مكتملة على الجلسة.',
    s5_note: 'مفتاح الأداة عام وآمن للتضمين في كود المتصفح. أما مفتاح API (Bearer token) فيخصص للاستخدام من جانب الخادم فقط — احتفظ به سراً ولا تُدرجه أبداً في كود الواجهة الأمامية أو التطبيق المحمول.',
    s6_title: 'إعداد قناة واتساب',
    s6_subtitle: 'مرّر رسائل واتساب بيزنس عبر شات بوت الذكاء الاصطناعي والوكلاء المباشرين.',
    s6_intro: 'يستخدم دمج واتساب Meta WhatsApp Business API (Cloud API). تربط حساب Meta Business الخاص بك — تُفوتر Meta مباشرةً رسوم المحادثة التي تتجاوز الحد المجاني.',
    s6_prereqs: 'المتطلبات الأساسية',
    s6_p1: 'حساب Meta Business',
    s6_p1Desc: 'حساب Meta Business Manager موثّق على business.facebook.com',
    s6_p2: 'تطبيق Meta Developer',
    s6_p2Desc: 'تطبيق Meta مضاف إليه منتج WhatsApp Business API (developers.facebook.com)',
    s6_p3: 'رقم هاتف موثّق',
    s6_p3Desc: 'رقم هاتف WhatsApp Business مضاف وموثّق داخل تطبيق Meta',
    s6_p4: 'رمز وصول دائم',
    s6_p4Desc: 'رمز وصول مستخدم النظام بإذن whatsapp_business_messaging',
    s6_step1Title: 'الخطوة 1 — إضافة قناة في البوابة',
    s6_step1_1: 'في بوابة العملاء، افتح شات بوتك وانتقل إلى قسم قنوات واتساب.',
    s6_step1_2: 'انقر على «إضافة قناة» وأدخل الحقول الأربعة:',
    s6_fField: 'الحقل',
    s6_fWhere: 'مكان العثور عليه',
    s6_fDispName: 'الاسم المعروض',
    s6_fDispNameDesc: 'أي تسمية، مثل «واتساب دعم العملاء»',
    s6_fPhoneId: 'معرّف رقم الهاتف',
    s6_fPhoneIdDesc: 'تطبيق Meta ← واتساب ← إعداد API ← Phone Number ID',
    s6_fToken: 'رمز الوصول',
    s6_fTokenDesc: 'تطبيق Meta ← مستخدمو النظام ← مستخدمك ← إنشاء رمز (مخزّن مشفراً)',
    s6_fWebhookToken: 'رمز التحقق من Webhook',
    s6_fWebhookTokenDesc: 'سلسلة سرية تخترعها — ستدخل نفس القيمة في Meta',
    s6_step1Note: 'بعد الحفظ، تعرض البوابة رابط Webhook الخاص بك. انسخه — ستحتاجه في الخطوة التالية.',
    s6_step2Title: 'الخطوة 2 — تهيئة Webhook في Meta',
    s6_step2_1: 'في لوحة تحكم تطبيق Meta، اذهب إلى واتساب ← التهيئة.',
    s6_step2_2: 'تحت Webhook، انقر تعديل وأدخل رابط Webhook المنسوخ من البوابة.',
    s6_step2_3: 'أدخل رمز التحقق من Webhook (نفس السلسلة المستخدمة في الخطوة 1).',
    s6_step2_4: 'انقر «تحقق وحفظ». ستتصل Meta بـ Webhook للتأكد من استجابته الصحيحة.',
    s6_step2_5: 'اشترك في حدث Webhook «messages» حتى ترسل Meta رسائلك الواردة.',
    s6_howTitle: 'كيف يعمل',
    s6_how1: 'يرسل عميل رسالة إلى رقم واتساب بيزنس الخاص بك.',
    s6_how2: 'تُسلّم Meta الرسالة إلى رابط Webhook الخاص بك.',
    s6_how3: 'يعالج الشات بوت الرسالة عبر نفس مسار الذكاء الاصطناعي المستخدم في أداة الموقع.',
    s6_how4: 'يُرسَل ردّ الذكاء الاصطناعي إلى العميل عبر Graph API الخاص بـ Meta.',
    s6_how5: 'إذا تُفعّل تحويل الوكيل، تظهر المحادثة في صندوق الوارد المباشر. تُسلَّم ردود الوكيل تلقائياً إلى العميل عبر واتساب.',
    s6_billing: 'الفوترة: توفر Meta 1,000 محادثة خدمة مجانية شهرياً لكل حساب واتساب بيزنس. بعد ذلك، تتقاضى Meta رسوماً لكل محادثة بحسب بلدك. تُحصَّل هذه الرسوم مباشرةً على حساب Meta Business الخاص بك — وليس عبر هذه المنصة.',
    s7_title: 'إعداد قناة ماسنجر',
    s7_subtitle: 'اربط صفحة فيسبوك الخاصة بك لاستقبال محادثات ماسنجر والرد عليها عبر شات بوتك والوكلاء المباشرين.',
    s7_intro: 'يستخدم دمج ماسنجر Meta Messenger Platform API. تربط صفحة فيسبوك تديرها — يستقبل شات بوتك الرسائل المرسلة إلى تلك الصفحة عبر ماسنجر.',
    s7_prereqs: 'المتطلبات الأساسية',
    s7_p1: 'حساب Meta Business',
    s7_p1Desc: 'حساب Meta Business Manager موثّق على business.facebook.com',
    s7_p2: 'صفحة فيسبوك',
    s7_p2Desc: 'صفحة فيسبوك تديرها (الصفحة التي يراسلها المستخدمون)',
    s7_p3: 'تطبيق Meta Developer',
    s7_p3Desc: 'تطبيق Meta مضاف إليه منتج ماسنجر (developers.facebook.com)',
    s7_p4: 'رمز وصول الصفحة',
    s7_p4Desc: 'رمز وصول دائم للصفحة بإذن pages_messaging',
    s7_step1Title: 'الخطوة 1 — إضافة قناة في البوابة',
    s7_step1_1: 'في بوابة العملاء، افتح شات بوتك وانتقل إلى قسم قنوات المراسلة.',
    s7_step1_2: 'انقر على تبويب ماسنجر، ثم انقر «إضافة قناة» وأدخل الحقول الأربعة:',
    s7_fField: 'الحقل',
    s7_fWhere: 'مكان العثور عليه',
    s7_fDispName: 'الاسم المعروض',
    s7_fDispNameDesc: 'أي تسمية، مثل «ماسنجر الشركة»',
    s7_fPageId: 'معرّف صفحة فيسبوك',
    s7_fPageIdDesc: 'صفحتك على فيسبوك ← معلومات ← معرّف الصفحة (رقمي)',
    s7_fToken: 'رمز الوصول',
    s7_fTokenDesc: 'تطبيق Meta ← ماسنجر ← إعداد API ← إنشاء رمز (مخزّن مشفراً)',
    s7_fWebhookToken: 'رمز التحقق من Webhook',
    s7_fWebhookTokenDesc: 'سلسلة سرية تخترعها — ستدخل نفس القيمة في Meta',
    s7_step2Title: 'الخطوة 2 — التهيئة في Meta',
    s7_step2_1: 'في لوحة تحكم تطبيق Meta، اذهب إلى ماسنجر ← الإعدادات ← Webhooks.',
    s7_step2_2: 'انقر تعديل وأدخل رابط Webhook المنسوخ من البوابة.',
    s7_step2_3: 'أدخل رمز التحقق من Webhook (نفس السلسلة المستخدمة في الخطوة 1).',
    s7_step2_4: 'اشترك في حقل messages وانقر «تحقق وحفظ».',
    s7_step2_5: 'تحت الاشتراكات، أضف صفحة فيسبوك حتى تستخدم هذا Webhook.',
    s7_howTitle: 'كيف يعمل',
    s7_how1: 'يرسل عميل رسالة إلى صفحة فيسبوك الخاصة بك عبر ماسنجر.',
    s7_how2: 'تُسلّم Meta الرسالة إلى رابط Webhook الخاص بك.',
    s7_how3: 'يعالج الشات بوت الرسالة عبر نفس مسار الذكاء الاصطناعي المستخدم في أداة الموقع.',
    s7_how4: 'يُرسَل ردّ الذكاء الاصطناعي إلى العميل عبر Graph API الخاص بـ Meta.',
    s7_how5: 'إذا تُفعّل تحويل الوكيل، تظهر المحادثة في صندوق الوارد المباشر. تُسلَّم ردود الوكيل تلقائياً إلى العميل عبر ماسنجر.',
    s7_billing: 'الفوترة: واجهة Messenger API مجانية حالياً للرسائل القياسية. قد تُقدم Meta رسوماً مستقبلاً. تُحصَّل أي رسوم مباشرةً على حساب Meta Business الخاص بك — وليس عبر هذه المنصة.',
    s8_title: 'إعداد قناة إنستغرام',
    s8_subtitle: 'اربط حساب إنستغرام بيزنس الخاص بك لاستقبال رسائل إنستغرام المباشرة والرد عليها عبر شات بوتك والوكلاء المباشرين.',
    s8_intro: 'يستخدم دمج رسائل إنستغرام المباشرة Meta Instagram Messaging API. يجب ربط حساب إنستغرام بيزنس الخاص بك بصفحة فيسبوك في Meta Business Suite.',
    s8_prereqs: 'المتطلبات الأساسية',
    s8_p1: 'حساب إنستغرام للأعمال',
    s8_p1Desc: 'حساب إنستغرام محوَّل إلى حساب أعمال أو مبدعين',
    s8_p2: 'ربط صفحة فيسبوك',
    s8_p2Desc: 'يجب ربط حساب إنستغرام بصفحة فيسبوك في Meta Business Suite',
    s8_p3: 'تطبيق Meta Developer',
    s8_p3Desc: 'تطبيق Meta مضاف إليه منتج Instagram Messaging',
    s8_p4: 'رمز وصول الصفحة',
    s8_p4Desc: 'رمز وصول دائم للصفحة المرتبطة بفيسبوك بإذن instagram_manage_messages',
    s8_step1Title: 'الخطوة 1 — إضافة قناة في البوابة',
    s8_step1_1: 'في بوابة العملاء، افتح شات بوتك وانتقل إلى قسم قنوات المراسلة.',
    s8_step1_2: 'انقر على تبويب إنستغرام، ثم انقر «إضافة قناة» وأدخل الحقول الأربعة:',
    s8_fField: 'الحقل',
    s8_fWhere: 'مكان العثور عليه',
    s8_fDispName: 'الاسم المعروض',
    s8_fDispNameDesc: 'أي تسمية، مثل «إنستغرام الشركة»',
    s8_fAccountId: 'معرّف حساب إنستغرام',
    s8_fAccountIdDesc: 'تطبيق Meta ← إنستغرام ← إعداد API ← Instagram Business Account ID (رقمي)',
    s8_fToken: 'رمز الوصول',
    s8_fTokenDesc: 'رمز وصول الصفحة المرتبطة بفيسبوك (مخزّن مشفراً)',
    s8_fWebhookToken: 'رمز التحقق من Webhook',
    s8_fWebhookTokenDesc: 'سلسلة سرية تخترعها — ستدخل نفس القيمة في Meta',
    s8_step2Title: 'الخطوة 2 — التهيئة في Meta',
    s8_step2_1: 'في لوحة تحكم تطبيق Meta، اذهب إلى إنستغرام ← الإعدادات ← Webhooks.',
    s8_step2_2: 'انقر تعديل وأدخل رابط Webhook المنسوخ من البوابة.',
    s8_step2_3: 'أدخل رمز التحقق من Webhook (نفس السلسلة المستخدمة في الخطوة 1).',
    s8_step2_4: 'اشترك في حقل messages وانقر «تحقق وحفظ».',
    s8_step2_5: 'تأكد من ربط حساب إنستغرام بيزنس الخاص بك بالصفحة المشتركة.',
    s8_howTitle: 'كيف يعمل',
    s8_how1: 'يرسل عميل رسالة مباشرة إلى حساب إنستغرام بيزنس الخاص بك.',
    s8_how2: 'تُسلّم Meta الرسالة إلى رابط Webhook الخاص بك.',
    s8_how3: 'يعالج الشات بوت الرسالة عبر نفس مسار الذكاء الاصطناعي المستخدم في أداة الموقع.',
    s8_how4: 'يُرسَل ردّ الذكاء الاصطناعي إلى العميل عبر Graph API الخاص بـ Meta.',
    s8_how5: 'إذا تُفعّل تحويل الوكيل، تظهر المحادثة في صندوق الوارد المباشر. تُسلَّم ردود الوكيل تلقائياً إلى العميل عبر رسائل إنستغرام المباشرة.',
    s8_note: 'ملاحظة: تتطلب أتمتة رسائل إنستغرام المباشرة الحصول على موافقة مراجعة التطبيق من Meta لإذن instagram_manage_messages. اختبر باستخدام حساباتك الخاصة أثناء التطوير. تُحصَّل أي رسوم Meta مباشرةً على حساب Meta Business الخاص بك.',
    needHelp: 'هل تحتاج إلى مساعدة؟',
    needHelpSubtitle: 'فريق الدعم لدينا جاهز لمساعدتك في عملية الدمج.',
    backToDocs: '→ العودة إلى التوثيق',
    contactSupport: 'تواصل مع الدعم',
  },
  cmmsDocs: {
    breadcrumb: 'التوثيق',
    breadcrumbPage: 'دليل CMMS',
    title: 'دليل مستخدم CMMS',
    heroSubtitle: 'أعدّ نظام إدارة الصيانة الخاص بك، وأدِر الأصول، وجدوِل الصيانة الوقائية، وأبقِ فريقك منسجماً — خطوة بخطوة.',
    onThisPage: 'في هذه الصفحة',
    toc_start: 'البدء',
    toc_assets: 'إدارة الأصول',
    toc_wo: 'أوامر العمل',
    toc_pm: 'الصيانة الوقائية',
    toc_inv: 'المخزون والمستودعات',
    toc_team: 'الفريق والصلاحيات',
    toc_reports: 'التقارير والتحليلات',
    s1_title: 'البدء',
    s1_subtitle: 'سجّل الدخول إلى بوابة العملاء وفعّل اشتراك CMMS الخاص بك.',
    s1_step1: 'سجّل الدخول إلى بوابة العملاء وانتقل إلى المنتجات.',
    s1_step2: 'اختر خطة CMMS المناسبة لحجم فريقك وانقر اشتراك.',
    s1_step3: 'بعد التفعيل، يظهر قسم CMMS في الشريط الجانبي الأيسر.',
    s1_step4: 'اذهب إلى CMMS ← لوحة التحكم للحصول على نظرة عامة على عملياتك.',
    s1_keyConcepts: 'المفاهيم الأساسية',
    s1_branch: 'الفرع',
    s1_branchDesc: 'موقع مادي أو فرع تعمل فيه شركتك (مثل مصنع أو مكتب)',
    s1_asset: 'الأصل',
    s1_assetDesc: 'أي معدة أو عنصر تريد تتبعه وصيانته',
    s1_wo: 'أمر العمل',
    s1_woDesc: 'مهمة مُسنَدة إلى فني لإصلاح أصل أو صيانته',
    s1_pm: 'جدول الصيانة الوقائية',
    s1_pmDesc: 'مهمة صيانة متكررة تعمل تلقائياً وفق جدول زمني',
    s1_inv: 'المخزون',
    s1_invDesc: 'قطع الغيار والمواد المخزّنة في مستودعاتك',
    s2_title: 'إدارة الأصول',
    s2_subtitle: 'سجّل وتتبّع جميع المعدات في فروعك.',
    s2_step1: 'انتقل إلى CMMS ← الأصول وانقر إضافة أصل.',
    s2_step2: 'أدخل تفاصيل الأصل — الاسم والفئة والفرع والموقع.',
    s2_step3: 'أضف مكونات (أجزاء فرعية) بترتيبات صيانة خاصة بها إذا رغبت.',
    s2_step4: 'أرفق صوراً أو أدلة أو وثائق الضمان حسب الحاجة.',
    s2_step5: 'احفظ الأصل. يمكن الآن تتبّعه وربطه بأوامر العمل.',
    s2_assetFields: 'حقول الأصل',
    s2_fField: 'الحقل',
    s2_fDesc: 'الوصف',
    s2_fName: 'الاسم',
    s2_fNameDesc: 'اسم الأصل المقروء (مثل ضاغط الهواء رقم 3)',
    s2_fCode: 'رمز الأصل',
    s2_fCodeDesc: 'مرجع داخلي فريد (مثل AC-003)',
    s2_fCategory: 'الفئة',
    s2_fCategoryDesc: 'نوع الأصل — كهربائي أو ميكانيكي أو تكييف وغيرها',
    s2_fBranch: 'الفرع',
    s2_fBranchDesc: 'الموقع الذي ينتمي إليه هذا الأصل',
    s2_fLocation: 'الموقع',
    s2_fLocationDesc: 'الغرفة أو المنطقة المحددة داخل الفرع',
    s2_fSerial: 'الرقم التسلسلي',
    s2_fSerialDesc: 'الرقم التسلسلي للمصنّع لتتبع الضمان',
    s2_fPurchase: 'تاريخ الشراء',
    s2_fPurchaseDesc: 'يُستخدم لحساب عمر الأصل وحالة الضمان',
    s2_fNextService: 'الصيانة القادمة',
    s2_fNextServiceDesc: 'التاريخ المحدد لزيارة الصيانة القادمة',
    s2_note: 'يتم تمييز الأصول التي تحتوي على مكونات مستحقة للاستبدال في لوحة تحكم CMMS حتى لا تفوتك أي نافذة صيانة.',
    s3_title: 'أوامر العمل',
    s3_subtitle: 'أنشئ مهام الصيانة وأسنِدها وتتبّعها.',
    s3_step1: 'اذهب إلى CMMS ← أوامر العمل وانقر إنشاء أمر عمل.',
    s3_step2: 'حدد الأصل واصف المشكلة وضع الأولوية (منخفض / متوسط / عالٍ / حرج).',
    s3_step3: 'أسنِد الأمر إلى فني من فريقك.',
    s3_step4: 'حدد تاريخ الإنجاز المتوقع.',
    s3_step5: 'يتلقى الفني المعيّن إشعاراً ويمكنه تحديث الحالة أثناء العمل.',
    s3_step6: 'بعد الحل، يُحدّد الفني الأمر كمكتمل ويضيف ملاحظة الخدمة.',
    s3_statuses: 'حالات أوامر العمل',
    s3_open: 'مفتوح',
    s3_openDesc: 'تم الإنشاء حديثاً، لم يبدأ بعد',
    s3_inProgress: 'قيد التنفيذ',
    s3_inProgressDesc: 'الفني يعمل عليه',
    s3_onHold: 'معلّق',
    s3_onHoldDesc: 'في انتظار قطع الغيار أو الموافقة',
    s3_completed: 'مكتمل',
    s3_completedDesc: 'العمل منتهٍ وتم التحقق منه',
    s4_title: 'الصيانة الوقائية',
    s4_subtitle: 'أتمتة الصيانة المتكررة لمنع الأعطال.',
    s4_step1: 'اذهب إلى CMMS ← جداول الصيانة الوقائية وانقر إضافة جدول.',
    s4_step2: 'حدد الأصل واصف مهمة الصيانة (مثل تغيير الزيت).',
    s4_step3: 'حدد التكرار — يومي أو أسبوعي أو شهري أو ربع سنوي أو سنوي.',
    s4_step4: 'عيّن فنياً افتراضياً للتعامل مع هذه المهمة.',
    s4_step5: 'احفظ. سيُنشئ النظام تلقائياً أمر عمل في كل تاريخ استحقاق.',
    s4_note: 'يتم تمييز جداول الصيانة الوقائية المستحقة خلال 7 أيام القادمة في لوحة تحكم CMMS حتى يتمكن فريقك من التحضير مسبقاً.',
    s5_title: 'المخزون والمستودعات',
    s5_subtitle: 'تتبّع قطع الغيار والمواد عبر جميع مواقع التخزين.',
    s5_step1: 'أنشئ مستودعات ضمن CMMS ← المستودعات (كل مستودع ينتمي إلى فرع).',
    s5_step2: 'أضف عناصر المخزون ضمن CMMS ← المخزون — حدد الاسم والوحدة والكمية والحد الأدنى للمخزون.',
    s5_step3: 'عيّن كل عنصر لمستودع.',
    s5_step4: 'عند إكمال أمر العمل، يُسجّل الفني القطع المستخدمة — ينقص المخزون تلقائياً.',
    s5_note: 'تُوضَع إشارة على العناصر التي تقل عن الحد الأدنى للمخزون في لوحة التحكم حتى تتمكن من إعادة الطلب قبل النفاد.',
    s6_title: 'الفريق والصلاحيات',
    s6_subtitle: 'ادعُ أعضاء الفريق وتحكم في ما يمكن لكل دور رؤيته وفعله.',
    s6_step1: 'اذهب إلى CMMS ← الفريق وانقر دعوة عضو.',
    s6_step2: 'أدخل عنوان البريد الإلكتروني للعضو وحدد دوره.',
    s6_step3: 'يتلقى المدعو بريداً إلكترونياً برابط لإعداد حسابه.',
    s6_step4: 'بعد تسجيل الدخول، يرى فقط الأقسام التي يسمح لها دوره.',
    s6_roles: 'أدوار CMMS',
    s6_roleCol: 'الدور',
    s6_accessCol: 'مستوى الصلاحية',
    s6_admin: 'مسؤول',
    s6_adminDesc: 'وصول كامل — يمكنه إدارة الفريق والأصول وأوامر العمل والتقارير والإعدادات',
    s6_supervisor: 'مشرف',
    s6_supervisorDesc: 'عرض وإدارة جميع أوامر العمل؛ يمكنه إنشاء جداول الصيانة الوقائية؛ بلا وصول للفوترة',
    s6_technician: 'فني',
    s6_technicianDesc: 'عرض وتحديث أوامر العمل المُسنَدة إليه؛ بلا وصول للإدارة',
    s6_viewer: 'مشاهد',
    s6_viewerDesc: 'وصول للقراءة فقط للأصول وأوامر العمل لأغراض المراجعة',
    s7_title: 'التقارير والتحليلات',
    s7_subtitle: 'قِس أداء الصيانة وحدد الأنماط.',
    s7_intro: 'انتقل إلى CMMS ← التقارير للوصول إلى التحليلات المدمجة. يمكن تصدير التقارير بصيغة PDF أو Excel.',
    s7_r1: 'ملخص أوامر العمل',
    s7_r1Desc: 'إجمالي أوامر العمل حسب الحالة (مفتوح / قيد التنفيذ / مكتمل)، ومتوسط وقت الحل، وعدد المتأخرة.',
    s7_r2: 'تقرير صحة الأصول',
    s7_r2Desc: 'قائمة بجميع الأصول مع تاريخ آخر صيانة والصيانة القادمة المجدولة وأوامر العمل المفتوحة.',
    s7_r3: 'أداء الفنيين',
    s7_r3Desc: 'أوامر العمل المنجزة لكل فني ومتوسط وقت الحل والمهام المتأخرة.',
    s7_r4: 'امتثال الصيانة الوقائية',
    s7_r4Desc: 'نسبة مهام الصيانة الوقائية المنجزة في الوقت المحدد مقابل المتأخرة عبر جميع الفروع.',
    s7_r5: 'استخدام المخزون',
    s7_r5Desc: 'القطع المستهلكة لكل فترة ومستويات المخزون والعناصر التي تقترب من الحد الأدنى.',
    needHelp: 'هل تحتاج إلى مساعدة؟',
    needHelpSubtitle: 'فريق الدعم لدينا جاهز لمساعدتك في إعداد CMMS.',
    backToDocs: '→ العودة إلى التوثيق',
    contactSupport: 'تواصل مع الدعم',
  },

  // Help Page
  helpPage: {
    title: 'مركز المساعدة',
    subtitle: 'ابحث عن إجابات واحصل على الدعم',
    getInTouch: 'تواصل معنا',
    faqTitle: 'الأسئلة الشائعة',
    stillNeedHelp: 'هل لا تزال بحاجة إلى مساعدة؟',
    stillNeedHelpDesc: 'فريق الدعم لدينا متاح على مدار الساعة طوال أيام الأسبوع لمساعدتك',
    contactSupport: 'تواصل مع الدعم',
    contact1Title: 'الدردشة المباشرة',
    contact1Desc: 'تحدث مع فريق الدعم لدينا في الوقت الفعلي',
    contact1Action: 'ابدأ الدردشة',
    contact1Available: 'متاح 24/7',
    contact2Title: 'الدعم عبر البريد الإلكتروني',
    contact2Desc: 'سنرد خلال 24 ساعة',
    contact2Action: 'أرسل بريدًا إلكترونيًا',
    contact2Available: 'support@mwbtechs.com',
    contact3Title: 'الدعم الهاتفي',
    contact3Desc: 'اتصل بنا للحصول على مساعدة فورية',
    contact3Action: 'اتصل الآن',
    contact3Available: '+1 (555) 123-4567',
    contact4Title: 'التوثيق',
    contact4Desc: 'تصفح أدلتنا الشاملة والدروس التعليمية',
    contact4Action: 'عرض التوثيق',
    contact4Available: 'موارد الخدمة الذاتية',
    faq1Cat: 'البدء',
    faq1q1: 'كيف أنشئ حسابًا؟',
    faq1a1: 'اضغط على زر "ابدأ الآن" واتبع خطوات التسجيل.',
    faq1q2: 'هل يمكنني رؤية المنصة قبل الشراء؟',
    faq1a2: 'نعم. اطلب عرضاً توضيحياً من صفحة التواصل وسنشرح لك المنصة.',
    faq1q3: 'هل تقدمون تجربة مجانية؟',
    faq1a3: 'لا. نقدم بدلاً من ذلك عرضاً توضيحياً موجهاً لتشاهد المنصة أثناء العمل قبل اختيار خطتك.',
    faq2Cat: 'الفواتير',
    faq2q1: 'كيف يمكنني تغيير خطتي؟',
    faq2a1: 'يمكنك ترقية خطتك أو تخفيضها في أي وقت من إعدادات حسابك.',
    faq2q2: 'ما طرق الدفع التي تقبلونها؟',
    faq2a2: 'نقبل جميع بطاقات الائتمان الرئيسية وPayPal والتحويلات البنكية للخطط السنوية.',
    faq2q3: 'هل تقدمون استردادًا للأموال؟',
    faq2a3: 'نعم، نقدم ضمان استرداد الأموال خلال 30 يومًا على جميع الاشتراكات الجديدة.',
    faq3Cat: 'الميزات',
    faq3q1: 'هل يمكنني استيراد بياناتي الحالية؟',
    faq3a1: 'نعم، ندعم استيراد البيانات من ملفات CSV وأنظمة CMMS الأخرى.',
    faq3q2: 'هل يوجد تطبيق للجوال؟',
    faq3a2: 'نعم، لدينا تطبيقات للجوال لكل من iOS وAndroid.',
    faq3q3: 'هل يمكنني التكامل مع أدوات أخرى؟',
    faq3a3: 'نعم، نقدم تكاملات مع الأدوات الشائعة وواجهة برمجية قوية.',
  },

  privacy: {
    pageTitle: 'سياسة الخصوصية | mwbTechs',
    metaDesc: 'اقرأ سياسة خصوصية mwbTechs. تعرف على كيفية جمع معلوماتك الشخصية واستخدامها وحمايتها.',
    title: 'سياسة الخصوصية',
    subtitle: 'خصوصيتك مهمة بالنسبة لنا',
    lastUpdated: 'آخر تحديث: 22 يناير 2026',
    introTitle: 'مقدمة',
    introText: 'تلتزم mwbTechs ("نحن" أو "لنا") بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها والإفصاح عنها وحمايتها عند استخدام موقعنا الإلكتروني وخدماتنا. يُرجى قراءة سياسة الخصوصية هذه بعناية. إذا كنت لا توافق على شروط سياسة الخصوصية هذه، يُرجى عدم الوصول إلى الموقع أو استخدام خدماتنا.',
    ctaTitle: 'أسئلة حول الخصوصية؟',
    ctaDesc: 'فريقنا هنا للمساعدة. تواصل معنا في أي وقت لأي أسئلة تتعلق بالخصوصية.',
    ctaBtn: 'التواصل مع فريق الخصوصية',
    relTermsTitle: 'شروط الخدمة',
    relTermsDesc: 'اقرأ الشروط والأحكام',
    relCookiesTitle: 'سياسة ملفات تعريف الارتباط',
    relCookiesDesc: 'تعرف على كيفية استخدامنا لملفات تعريف الارتباط',
    relSecurityTitle: 'الأمان',
    relSecurityDesc: 'كيف نحمي بياناتك',
    s1Title: '1. المعلومات التي نجمعها',
    s1Content: `<p class="mb-4">نجمع المعلومات التي تزودنا بها مباشرةً، بما في ذلك:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>معلومات الحساب:</strong> الاسم وعنوان البريد الإلكتروني واسم الشركة وكلمة المرور عند إنشاء حساب</li><li><strong>معلومات الملف الشخصي:</strong> معلومات إضافية تختار تقديمها في ملفك الشخصي</li><li><strong>معلومات الدفع:</strong> تفاصيل الفواتير ومعلومات بطاقة الدفع (تُعالج بأمان من قِبل مزودي خدمة الدفع لدينا)</li><li><strong>المراسلات:</strong> المعلومات التي تقدمها عند التواصل معنا أو المشاركة في الاستطلاعات</li><li><strong>بيانات الاستخدام:</strong> معلومات حول كيفية استخدامك لخدماتنا، بما في ذلك بيانات السجل ومعلومات الجهاز وملفات تعريف الارتباط</li></ul>`,
    s2Title: '2. كيف نستخدم معلوماتك',
    s2Content: `<p class="mb-4">نستخدم المعلومات التي نجمعها من أجل:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>تقديم خدماتنا وصيانتها وتحسينها</li><li>معالجة المعاملات وإرسال المعلومات ذات الصلة</li><li>إرسال الإشعارات التقنية والتحديثات وتنبيهات الأمان ورسائل الدعم</li><li>الرد على تعليقاتك وأسئلتك وتقديم خدمة العملاء</li><li>مراقبة الاتجاهات والاستخدام والأنشطة وتحليلها</li><li>اكتشاف المشكلات التقنية والأنشطة الاحتيالية ومعالجتها والوقاية منها</li><li>تخصيص تجربتك وتحسينها</li><li>إرسال اتصالات تسويقية (بموافقتك)</li></ul>`,
    s3Title: '3. مشاركة المعلومات والإفصاح عنها',
    s3Content: `<p class="mb-4">لا نبيع معلوماتك الشخصية. قد نشارك معلوماتك فقط في الحالات التالية:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>بموافقتك:</strong> سنشارك المعلومات بموافقتك الصريحة</li><li><strong>مزودو الخدمات:</strong> قد نشارك المعلومات مع مزودي خدمات طرف ثالث يؤدون خدمات نيابةً عنا</li><li><strong>المتطلبات القانونية:</strong> قد نكشف عن المعلومات إذا طلبها القانون أو استجابةً للطلبات القانونية</li><li><strong>عمليات نقل الأعمال:</strong> قد تُنقل المعلومات في إطار عمليات الاندماج أو الاستحواذ أو بيع الأصول</li><li><strong>حماية الحقوق:</strong> لحماية حقوق وممتلكات وسلامة mwbTechs ومستخدمينا والعامة</li></ul>`,
    s4Title: '4. أمان البيانات',
    s4Content: `<p class="mb-4">نأخذ أمان معلوماتك بجدية تامة وننفذ تدابير تقنية وتنظيمية مناسبة لحمايتها:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>تشفير البيانات أثناء النقل وفي وضع السكون وفق بروتوكولات معيارية في الصناعة</li><li>تقييمات أمنية منتظمة واختبارات الاختراق</li><li>ضوابط الوصول وآليات المصادقة</li><li>تدريب الموظفين على حماية البيانات وممارسات الأمان</li><li>إجراءات الاستجابة للحوادث وبروتوكولات الإخطار بالاختراقات</li></ul><p class="mb-4">غير أنه لا توجد طريقة نقل عبر الإنترنت أو تخزين إلكتروني آمنة بنسبة 100%، ولا يمكننا ضمان الأمان المطلق.</p>`,
    s5Title: '5. الاحتفاظ بالبيانات',
    s5Content: `<p class="mb-4">نحتفظ بمعلوماتك الشخصية طالما كان ذلك ضرورياً من أجل:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>تزويدك بخدماتنا</li><li>الامتثال للالتزامات القانونية</li><li>حل النزاعات وإنفاذ اتفاقياتنا</li></ul><p class="mb-4">عندما لم نعد بحاجة إلى معلوماتك، نحذفها أو نجهّلها بأمان.</p>`,
    s6Title: '6. حقوقك وخياراتك',
    s6Content: `<p class="mb-4">لديك حقوق معينة تتعلق بمعلوماتك الشخصية:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>الوصول:</strong> طلب الاطلاع على المعلومات الشخصية التي نحتفظ بها عنك</li><li><strong>التصحيح:</strong> طلب تصحيح المعلومات غير الدقيقة أو غير المكتملة</li><li><strong>الحذف:</strong> طلب حذف معلوماتك الشخصية</li><li><strong>قابلية النقل:</strong> طلب نسخة من معلوماتك بتنسيق قابل للنقل</li><li><strong>إلغاء الاشتراك:</strong> إلغاء الاشتراك في الاتصالات التسويقية في أي وقت</li><li><strong>ملفات تعريف الارتباط:</strong> التحكم في ملفات تعريف الارتباط من خلال إعدادات متصفحك</li></ul><p class="mb-4">لممارسة هذه الحقوق، يُرجى التواصل معنا على privacy@mwbtechs.com.</p>`,
    s7Title: '7. ملفات تعريف الارتباط وتقنيات التتبع',
    s7Content: `<p class="mb-4">نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لجمع المعلومات حول استخدامك لخدماتنا وتتبعها. يمكنك التحكم في ملفات تعريف الارتباط من خلال إعدادات متصفحك. لمزيد من المعلومات، راجع <a href="/cookies" class="text-primary-600 hover:underline">سياسة ملفات تعريف الارتباط</a> الخاصة بنا.</p>`,
    s8Title: '8. النقل الدولي للبيانات',
    s8Content: `<p class="mb-4">قد تُنقل معلوماتك وتُعالَج في دول غير بلد إقامتك. نحرص على وجود ضمانات مناسبة لحماية معلوماتك وفقاً لسياسة الخصوصية هذه.</p>`,
    s9Title: '9. خصوصية الأطفال',
    s9Content: `<p class="mb-4">خدماتنا غير مخصصة للأطفال الذين تقل أعمارهم عن 16 عاماً. لا نجمع عن قصد معلومات شخصية من أطفال دون سن 16. إذا كنت تعتقد أننا جمعنا معلومات من طفل دون سن 16، يُرجى التواصل معنا فوراً.</p>`,
    s10Title: '10. التغييرات على سياسة الخصوصية هذه',
    s10Content: `<p class="mb-4">قد نُحدّث سياسة الخصوصية هذه من وقت لآخر. سنُخطرك بأي تغييرات جوهرية بنشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث". نشجعك على مراجعة سياسة الخصوصية هذه بصفة دورية.</p>`,
    s11Title: '11. اتصل بنا',
    s11Content: `<p class="mb-4">إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يُرجى التواصل معنا:</p><ul class="list-none space-y-2"><li><strong>البريد الإلكتروني:</strong> privacy@mwbtechs.com</li><li><strong>العنوان:</strong> 123 Tech Street, San Francisco, CA 94105, USA</li><li><strong>الهاتف:</strong> +1 (555) 123-4567</li></ul>`,
  },

  terms: {
    pageTitle: 'شروط الخدمة | mwbTechs',
    metaDesc: 'اقرأ شروط خدمة mwbTechs. تعرف على الشروط والأحكام الخاصة باستخدام خدماتنا.',
    title: 'شروط الخدمة',
    subtitle: 'يُرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا',
    lastUpdated: 'آخر تحديث: 22 يناير 2026',
    introTitle: 'الموافقة على الشروط',
    introText: 'تُشكّل شروط الخدمة هذه اتفاقية ملزمة قانونياً بينك وبين mwbTechs فيما يتعلق باستخدامك لموقعنا الإلكتروني وخدماتنا. بالوصول إلى خدماتنا أو استخدامها، تُقرّ بأنك قرأت هذه الشروط وفهمتها ووافقت على الالتزام بها.',
    ctaTitle: 'أسئلة حول هذه الشروط؟',
    ctaDesc: 'فريقنا القانوني متاح للإجابة على أي أسئلة لديك.',
    ctaBtn: 'التواصل مع الفريق القانوني',
    relPrivacyTitle: 'سياسة الخصوصية',
    relPrivacyDesc: 'كيف نحمي بياناتك',
    relCookiesTitle: 'سياسة ملفات تعريف الارتباط',
    relCookiesDesc: 'تعرف على كيفية استخدامنا لملفات تعريف الارتباط',
    relSecurityTitle: 'الأمان',
    relSecurityDesc: 'ممارسات الأمان لدينا',
    s1Title: '1. قبول الشروط',
    s1Content: `<p class="mb-4">بالوصول إلى خدمات mwbTechs واستخدامها، فإنك تقبل هذه الشروط وتوافق على الالتزام بها وبسياسة الخصوصية الخاصة بنا. إذا لم توافق على هذه الشروط، يُرجى عدم استخدام خدماتنا.</p>`,
    s2Title: '2. وصف الخدمات',
    s2Content: `<p class="mb-4">تقدم mwbTechs:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>برنامج CMMS (نظام إدارة الصيانة المحوسبة)</li><li>حلول الدردشة الآلية المدعومة بالذكاء الاصطناعي</li><li>خدمات استشارات التحول الرقمي</li><li>خدمات تطوير البرمجيات المخصصة</li><li>خدمات الدعم والصيانة المرتبطة</li></ul><p class="mb-4">نحتفظ بالحق في تعديل أي جزء من خدماتنا أو تعليقه أو إيقافه في أي وقت مع إشعار مناسب.</p>`,
    s3Title: '3. تسجيل الحساب',
    s3Content: `<p class="mb-4">لاستخدام خدماتنا، يجب عليك:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>أن يكون عمرك 18 عاماً على الأقل أو بلوغ سن الرشد في ولايتك القضائية</li><li>تقديم معلومات دقيقة وحديثة وكاملة عند التسجيل</li><li>الحفاظ على معلومات حسابك وتحديثها بصفة فورية</li><li>الحفاظ على سرية كلمة المرور وأمانها</li><li>إخطارنا فوراً بأي استخدام غير مصرح به لحسابك</li></ul><p class="mb-4">أنت مسؤول عن جميع الأنشطة التي تجري تحت حسابك.</p>`,
    s4Title: '4. الاشتراك والفواتير',
    s4Content: `<p class="mb-4"><strong>4.1 الفترة التجريبية المجانية:</strong> نقدم فترة تجريبية مجانية مدتها 14 يوماً للعملاء الجدد. لا تلزم بطاقة ائتمان لبدء الفترة التجريبية. يمكنك الإلغاء في أي وقت خلال فترة الفترة التجريبية.</p><p class="mb-4"><strong>4.2 الاشتراكات المدفوعة:</strong> بعد انتهاء فترة الفترة التجريبية، ستُفرض عليك رسوم وفقاً للخطة المختارة (شهرية أو سنوية). الرسوم غير قابلة للاسترداد إلا إذا اقتضى القانون ذلك أو كما هو منصوص عليه صراحةً في هذه الشروط.</p><p class="mb-4"><strong>4.3 التجديد التلقائي:</strong> تتجدد الاشتراكات تلقائياً ما لم يُلغَ قبل تاريخ التجديد. ستُفرض عليك الرسوم باستخدام طريقة الدفع المختارة.</p><p class="mb-4"><strong>4.4 تغييرات الأسعار:</strong> قد نغيّر أسعارنا مع إشعار مدته 30 يوماً. تسري التغييرات في تاريخ تجديدك التالي.</p><p class="mb-4"><strong>4.5 المبالغ المستردة:</strong> نقدم ضماناً لاسترداد الأموال خلال 30 يوماً للاشتراكات المدفوعة الجديدة. تواصل معنا في غضون 30 يوماً من دفعتك الأولى لاسترداد كامل.</p>`,
    s5Title: '5. الاستخدام المقبول',
    s5Content: `<p class="mb-4">توافق على عدم:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>استخدام خدماتنا لأي غرض غير قانوني أو بما يخالف القوانين</li><li>تحميل أو نقل أو توزيع أي رمز ضار أو فيروسات أو برمجيات خبيثة</li><li>محاولة الوصول غير المصرح به إلى أنظمتنا أو حسابات المستخدمين الآخرين</li><li>التدخل في سلامة أو أداء خدماتنا أو تعطيلها</li><li>استخدام خدماتنا لإرسال رسائل غير مرغوب فيها أو اتصالات غير مطلوبة</li><li>استخراج البيانات أو نسخ خدماتنا أو إجراء هندسة عكسية عليها</li><li>إعادة بيع أو إعادة توزيع خدماتنا دون إذن</li><li>استخدام خدماتنا بأي طريقة قد تضر بسمعتنا</li></ul>`,
    s6Title: '6. الملكية الفكرية',
    s6Content: `<p class="mb-4"><strong>6.1 ملكيتنا الفكرية:</strong> جميع المحتويات والميزات والوظائف الخاصة بخدماتنا مملوكة لـ mwbTechs ومحمية بموجب قوانين حقوق النشر والعلامات التجارية وغيرها من قوانين الملكية الفكرية.</p><p class="mb-4"><strong>6.2 محتواك:</strong> تحتفظ بملكية أي محتوى تقدمه لخدماتنا. بتقديم المحتوى، تمنحنا ترخيصاً لاستخدام هذا المحتوى وتخزينه وعرضه بالقدر اللازم لتقديم خدماتنا.</p><p class="mb-4"><strong>6.3 الملاحظات:</strong> أي ملاحظات أو اقتراحات أو أفكار تقدمها تصبح ملكيتنا ويجوز استخدامها دون تعويض أو إسناد.</p>`,
    s7Title: '7. البيانات والخصوصية',
    s7Content: `<p class="mb-4">نجمع بياناتك ونعالجها كما هو موضح في <a href="/privacy" class="text-primary-600 hover:underline">سياسة الخصوصية</a> الخاصة بنا. أنت مسؤول عن التأكد من أن لديك الحق في تقديم أي بيانات لخدماتنا.</p><p class="mb-4">نطبق تدابير أمنية معيارية في الصناعة، لكن لا يمكننا ضمان الأمان المطلق. تستخدم خدماتنا على مسؤوليتك الخاصة.</p>`,
    s8Title: '8. اتفاقية مستوى الخدمة (SLA)',
    s8Content: `<p class="mb-4">نسعى للحفاظ على نسبة توافر 99.9% لخدماتنا، باستثناء الصيانة المجدولة. تفاصيل اتفاقية مستوى الخدمة متاحة في اتفاقية الخدمة أو عند الطلب لعملاء المؤسسات.</p>`,
    s9Title: '9. الضمانات وإخلاء المسؤولية',
    s9Content: `<p class="mb-4"><strong>9.1 الخدمات "كما هي":</strong> تُقدَّم خدماتنا "كما هي" و"حسب التوافر" دون أي ضمانات من أي نوع، صريحة كانت أم ضمنية.</p><p class="mb-4"><strong>9.2 لا ضمان:</strong> لا نضمن أن خدماتنا ستكون دون انقطاع أو خالية من الأخطاء أو آمنة تماماً.</p><p class="mb-4"><strong>9.3 خدمات الطرف الثالث:</strong> لسنا مسؤولين عن أي خدمات أو تكاملات طرف ثالث قد تستخدمها مع خدماتنا.</p>`,
    s10Title: '10. تحديد المسؤولية',
    s10Content: `<p class="mb-4">إلى أقصى حد يسمح به القانون:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>لن تكون mwbTechs مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية</li><li>لن تتجاوز مسؤوليتنا الإجمالية المبلغ الذي دفعته لنا في الـ 12 شهراً السابقة للمطالبة</li><li>لسنا مسؤولين عن أي خسارة في البيانات أو الأرباح أو الفرص التجارية</li></ul>`,
    s11Title: '11. التعويض',
    s11Content: `<p class="mb-4">توافق على تعويض mwbTechs وإبراء ذمتها من أي مطالبات أو أضرار أو نفقات ناشئة عن استخدامك لخدماتنا أو انتهاك هذه الشروط أو انتهاك حقوق أي طرف آخر.</p>`,
    s12Title: '12. الإنهاء',
    s12Content: `<p class="mb-4"><strong>12.1 من قِبلك:</strong> يمكنك إلغاء اشتراكك في أي وقت من خلال إعدادات حسابك أو بالتواصل معنا.</p><p class="mb-4"><strong>12.2 من قِبلنا:</strong> قد نعلّق حسابك أو نُنهيه إذا انتهكت هذه الشروط أو أخفقت في سداد الرسوم أو لأي سبب معقول آخر مع إشعار مناسب.</p><p class="mb-4"><strong>12.3 أثر الإنهاء:</strong> عند الإنهاء، يتوقف حقك في استخدام خدماتنا فوراً. قد نحذف بياناتك بعد فترة معقولة.</p>`,
    s13Title: '13. القانون الحاكم',
    s13Content: `<p class="mb-4">تخضع هذه الشروط لقوانين ولاية كاليفورنيا بالولايات المتحدة الأمريكية، بصرف النظر عن أحكام تعارض القوانين. تُحسم أي نزاعات أمام محاكم مقاطعة سان فرانسيسكو، كاليفورنيا.</p>`,
    s14Title: '14. التغييرات على الشروط',
    s14Content: `<p class="mb-4">قد نُحدّث هذه الشروط من وقت لآخر. سنُخطرك بالتغييرات الجوهرية عبر البريد الإلكتروني أو من خلال خدماتنا. استمرارك في الاستخدام بعد التغييرات يُعدّ قبولاً للشروط الجديدة.</p>`,
    s15Title: '15. معلومات الاتصال',
    s15Content: `<p class="mb-4">لأي أسئلة حول هذه الشروط، تواصل معنا:</p><ul class="list-none space-y-2"><li><strong>البريد الإلكتروني:</strong> legal@mwbtechs.com</li><li><strong>العنوان:</strong> 123 Tech Street, San Francisco, CA 94105, USA</li><li><strong>الهاتف:</strong> +1 (555) 123-4567</li></ul>`,
  },

  security: {
    pageTitle: 'الأمان | mwbTechs',
    metaDesc: 'تعرّف على ممارسات الأمان في mwbTechs وكيف نحمي بياناتك.',
    title: 'الأمان',
    subtitle: 'أمان بمستوى المؤسسات لحماية بياناتك',
    m1Title: 'التشفير',
    m1Desc: 'جميع البيانات مشفّرة أثناء النقل (TLS 1.3) وعند التخزين (AES-256) باستخدام بروتوكولات قياسية في الصناعة.',
    m2Title: 'البنية التحتية الآمنة',
    m2Desc: 'مستضاف على بنية تحتية سحابية بمستوى المؤسسات مع الامتثال لـ SOC 2 Type II وعمليات تدقيق أمني منتظمة.',
    m3Title: 'ضوابط الوصول',
    m3Desc: 'المصادقة متعددة العوامل والتحكم في الوصول المستند إلى الأدوار وتسجيل التدقيق الشامل.',
    m4Title: 'الاختبارات المنتظمة',
    m4Desc: 'فحص مستمر للثغرات واختبارات الاختراق وتقييمات الأمان من قِبل خبراء خارجيين.',
    certTitle: 'الشهادات والامتثال',
    cert1: 'معتمد SOC 2 Type II',
    cert2: 'متوافق مع GDPR',
    cert3: 'معتمد ISO 27001',
    cert4: 'متوافق مع HIPAA (المؤسسات)',
    cert5: 'متوافق مع PCI DSS',
    reportTitle: 'الإبلاغ عن مشكلات الأمان',
    reportDesc: 'إذا اكتشفت ثغرة أمنية، يرجى الإبلاغ عنها فوراً على security@mwbtechs.com. نأخذ جميع تقارير الأمان بجدية ونستجيب بسرعة.',
    reportBtn: 'الإبلاغ عن مشكلة',
    relPrivacyTitle: 'سياسة الخصوصية',
    relTermsTitle: 'شروط الاستخدام',
  },

};

export default ar;
